/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * GeoStrat API
 * Geopolitical strategy game simulation API - manage nations, diplomacy, trade, and military operations
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminAccount,
  AdminAccountRequest,
  AdminAccountSchedule,
  AdminAccountScheduleRequest,
  AdminArticle,
  AdminArticleRequest,
  AdminBadge,
  AdminBadgeAward,
  AdminBadgeAwardRequest,
  AdminBadgeRequest,
  AdminClassName,
  AdminClassNameRequest,
  AdminComment,
  AdminCommentRequest,
  AdminItem,
  AdminNations,
  AdminNationsRequest,
  AdminRole,
  AdminUserClass,
  AdminUserClassBadgeAward,
  AdminUserClassBadgeAwardRequest,
  AdminUserClassCreateRequestRequest,
  AdminUserClassRequest,
  AdvanceDay,
  AdvanceDayRequest,
  ApiError,
  DrfadminAccountSchedulesListParams,
  DrfadminAccountsListParams,
  DrfadminArticlesListParams,
  DrfadminBadgeAwardsListParams,
  DrfadminBadgesListParams,
  DrfadminClassesListParams,
  DrfadminCommentsListParams,
  DrfadminGoogleClassroomCoursesRetrieveParams,
  DrfadminGoogleClassroomStudentsRetrieveParams,
  DrfadminItemsListParams,
  DrfadminMilitaryAlliancesListParams,
  DrfadminNationsListParams,
  DrfadminNaturalDisastersListParams,
  DrfadminNotesListParams,
  DrfadminPeaceTreatiesListParams,
  DrfadminPopulationChangeEventListParams,
  DrfadminPurchasesListParams,
  DrfadminResourceTypesListParams,
  DrfadminResourcesListParams,
  DrfadminRolePermissionsListParams,
  DrfadminRolesListParams,
  DrfadminSubpoenasListParams,
  DrfadminTradeAlliancesListParams,
  DrfadminTradesListParams,
  DrfadminUserClassBadgeAwardsListParams,
  DrfadminUsersListParams,
  DrfadminUsersMyClassesListParams,
  DrfadminWarningsListParams,
  DrfadminWarsListParams,
  GoogleClassroomCoursesResponse,
  GoogleClassroomStudentsResponse,
  MoveToClassRequestRequest,
  NaturalDisasterCreate,
  NaturalDisasterCreateRequest,
  NewMilitaryAlliance,
  NewMilitaryAllianceRequest,
  NewTrade,
  NewTradeAlliance,
  NewTradeAllianceRequest,
  NewTradeRequest,
  Note,
  NoteRequest,
  OpenAIPromptRequestRequest,
  OpenAIPromptResponse,
  PaginatedAdminAccountList,
  PaginatedAdminAccountScheduleList,
  PaginatedAdminArticleList,
  PaginatedAdminBadgeAwardList,
  PaginatedAdminBadgeList,
  PaginatedAdminClassNameList,
  PaginatedAdminCommentList,
  PaginatedAdminItemList,
  PaginatedAdminNationsList,
  PaginatedAdminRoleList,
  PaginatedAdminUserClassBadgeAwardList,
  PaginatedAdminUserClassList,
  PaginatedNaturalDisasterCreateList,
  PaginatedNewMilitaryAllianceList,
  PaginatedNewTradeAllianceList,
  PaginatedNewTradeList,
  PaginatedNoteList,
  PaginatedPeaceTreatyList,
  PaginatedPopulationChangeEventList,
  PaginatedPurchaseList,
  PaginatedResourceList,
  PaginatedResourceTypeList,
  PaginatedRolePermissionsList,
  PaginatedSubpoenaList,
  PaginatedWarList,
  PaginatedWarningList,
  PatchedAdminAccountRequest,
  PatchedAdminAccountScheduleRequest,
  PatchedAdminArticleRequest,
  PatchedAdminBadgeAwardRequest,
  PatchedAdminBadgeRequest,
  PatchedAdminClassNameRequest,
  PatchedAdminCommentRequest,
  PatchedAdminNationsRequest,
  PatchedAdminUserClassBadgeAwardRequest,
  PatchedAdminUserClassRequest,
  PatchedNaturalDisasterCreateRequest,
  PatchedNewMilitaryAllianceRequest,
  PatchedNewTradeAllianceRequest,
  PatchedNewTradeRequest,
  PatchedNoteRequest,
  PatchedPeaceTreatyRequest,
  PatchedPopulationChangeEventRequest,
  PatchedPurchaseRequest,
  PatchedResourceRequest,
  PatchedSubpoenaRequest,
  PatchedWarRequest,
  PatchedWarningRequest,
  PeaceTreaty,
  PeaceTreatyRequest,
  PopulationChangeEvent,
  PopulationChangeEventRequest,
  Purchase,
  PurchaseRequest,
  ResetMilitaryRequest,
  ResetMilitaryResponse,
  Resource,
  ResourceRequest,
  ResourceType,
  RolePermissions,
  SelectUserClassResponse,
  Subpoena,
  SubpoenaRequest,
  UpdateNewsRequest,
  UpdateNewsResponse,
  UpdatePopulationRequest,
  UpdatePopulationResponse,
  UpdateResourcesRequest,
  UpdateResourcesResponse,
  UserGeneratedContentItem,
  War,
  WarRequest,
  Warning,
  WarningRequest
} from '../models';

import { customInstance } from '.././custom-instance';
import type { ErrorType } from '.././custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const drfadminAccountSchedulesList = (
    params?: DrfadminAccountSchedulesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminAccountScheduleList>(
      {url: `/drfadmin/account-schedules/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminAccountSchedulesListQueryKey = (params?: DrfadminAccountSchedulesListParams,) => {
    return [
    `/drfadmin/account-schedules/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminAccountSchedulesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError = ErrorType<ApiError>>(params?: DrfadminAccountSchedulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminAccountSchedulesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminAccountSchedulesList>>> = ({ signal }) => drfadminAccountSchedulesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminAccountSchedulesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountSchedulesList>>>
export type DrfadminAccountSchedulesListQueryError = ErrorType<ApiError>


export function useDrfadminAccountSchedulesList<TData = Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminAccountSchedulesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminAccountSchedulesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminAccountSchedulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminAccountSchedulesList<TData = Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminAccountSchedulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminAccountSchedulesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminAccountSchedulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminAccountSchedulesList<TData = Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminAccountSchedulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminAccountSchedulesList<TData = Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminAccountSchedulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminAccountSchedulesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminAccountSchedulesCreate = (
    adminAccountScheduleRequest: AdminAccountScheduleRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminAccountSchedule>(
      {url: `/drfadmin/account-schedules/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminAccountScheduleRequest, signal
    },
      options);
    }




export const getDrfadminAccountSchedulesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesCreate>>, TError,{data: AdminAccountScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesCreate>>, TError,{data: AdminAccountScheduleRequest}, TContext> => {

const mutationKey = ['drfadminAccountSchedulesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminAccountSchedulesCreate>>, {data: AdminAccountScheduleRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminAccountSchedulesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminAccountSchedulesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountSchedulesCreate>>>
    export type DrfadminAccountSchedulesCreateMutationBody = AdminAccountScheduleRequest
    export type DrfadminAccountSchedulesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminAccountSchedulesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesCreate>>, TError,{data: AdminAccountScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminAccountSchedulesCreate>>,
        TError,
        {data: AdminAccountScheduleRequest},
        TContext
      > => {
      return useMutation(getDrfadminAccountSchedulesCreateMutationOptions(options), queryClient);
    }
    export const drfadminAccountSchedulesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminAccountSchedule>(
      {url: `/drfadmin/account-schedules/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminAccountSchedulesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/account-schedules/${id}/`
    ] as const;
    }


export const getDrfadminAccountSchedulesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminAccountSchedulesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>> = ({ signal }) => drfadminAccountSchedulesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminAccountSchedulesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>>
export type DrfadminAccountSchedulesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminAccountSchedulesRetrieve<TData = Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminAccountSchedulesRetrieve<TData = Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminAccountSchedulesRetrieve<TData = Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminAccountSchedulesRetrieve<TData = Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminAccountSchedulesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminAccountSchedulesUpdate = (
    id: number,
    adminAccountScheduleRequest: AdminAccountScheduleRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminAccountSchedule>(
      {url: `/drfadmin/account-schedules/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminAccountScheduleRequest, signal
    },
      options);
    }




export const getDrfadminAccountSchedulesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesUpdate>>, TError,{id: number;data: AdminAccountScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesUpdate>>, TError,{id: number;data: AdminAccountScheduleRequest}, TContext> => {

const mutationKey = ['drfadminAccountSchedulesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminAccountSchedulesUpdate>>, {id: number;data: AdminAccountScheduleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminAccountSchedulesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminAccountSchedulesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountSchedulesUpdate>>>
    export type DrfadminAccountSchedulesUpdateMutationBody = AdminAccountScheduleRequest
    export type DrfadminAccountSchedulesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminAccountSchedulesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesUpdate>>, TError,{id: number;data: AdminAccountScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminAccountSchedulesUpdate>>,
        TError,
        {id: number;data: AdminAccountScheduleRequest},
        TContext
      > => {
      return useMutation(getDrfadminAccountSchedulesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminAccountSchedulesPartialUpdate = (
    id: number,
    patchedAdminAccountScheduleRequest?: PatchedAdminAccountScheduleRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminAccountSchedule>(
      {url: `/drfadmin/account-schedules/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminAccountScheduleRequest, signal
    },
      options);
    }




export const getDrfadminAccountSchedulesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesPartialUpdate>>, TError,{id: number;data?: PatchedAdminAccountScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesPartialUpdate>>, TError,{id: number;data?: PatchedAdminAccountScheduleRequest}, TContext> => {

const mutationKey = ['drfadminAccountSchedulesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminAccountSchedulesPartialUpdate>>, {id: number;data?: PatchedAdminAccountScheduleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminAccountSchedulesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminAccountSchedulesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountSchedulesPartialUpdate>>>
    export type DrfadminAccountSchedulesPartialUpdateMutationBody = PatchedAdminAccountScheduleRequest | undefined
    export type DrfadminAccountSchedulesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminAccountSchedulesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesPartialUpdate>>, TError,{id: number;data?: PatchedAdminAccountScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminAccountSchedulesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminAccountScheduleRequest},
        TContext
      > => {
      return useMutation(getDrfadminAccountSchedulesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminAccountSchedulesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/account-schedules/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminAccountSchedulesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminAccountSchedulesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminAccountSchedulesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminAccountSchedulesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminAccountSchedulesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountSchedulesDestroy>>>

    export type DrfadminAccountSchedulesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminAccountSchedulesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountSchedulesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminAccountSchedulesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminAccountSchedulesDestroyMutationOptions(options), queryClient);
    }
    export const drfadminAccountsList = (
    params?: DrfadminAccountsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminAccountList>(
      {url: `/drfadmin/accounts/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminAccountsListQueryKey = (params?: DrfadminAccountsListParams,) => {
    return [
    `/drfadmin/accounts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminAccountsListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminAccountsList>>, TError = ErrorType<ApiError>>(params?: DrfadminAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminAccountsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminAccountsList>>> = ({ signal }) => drfadminAccountsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminAccountsListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountsList>>>
export type DrfadminAccountsListQueryError = ErrorType<ApiError>


export function useDrfadminAccountsList<TData = Awaited<ReturnType<typeof drfadminAccountsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminAccountsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminAccountsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminAccountsList<TData = Awaited<ReturnType<typeof drfadminAccountsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminAccountsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminAccountsList<TData = Awaited<ReturnType<typeof drfadminAccountsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminAccountsList<TData = Awaited<ReturnType<typeof drfadminAccountsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminAccountsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminAccountsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminAccountsCreate = (
    adminAccountRequest: AdminAccountRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminAccount>(
      {url: `/drfadmin/accounts/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminAccountRequest, signal
    },
      options);
    }




export const getDrfadminAccountsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsCreate>>, TError,{data: AdminAccountRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsCreate>>, TError,{data: AdminAccountRequest}, TContext> => {

const mutationKey = ['drfadminAccountsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminAccountsCreate>>, {data: AdminAccountRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminAccountsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminAccountsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountsCreate>>>
    export type DrfadminAccountsCreateMutationBody = AdminAccountRequest
    export type DrfadminAccountsCreateMutationError = ErrorType<ApiError>

    export const useDrfadminAccountsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsCreate>>, TError,{data: AdminAccountRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminAccountsCreate>>,
        TError,
        {data: AdminAccountRequest},
        TContext
      > => {
      return useMutation(getDrfadminAccountsCreateMutationOptions(options), queryClient);
    }
    export const drfadminAccountsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminAccount>(
      {url: `/drfadmin/accounts/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminAccountsRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/accounts/${id}/`
    ] as const;
    }


export const getDrfadminAccountsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminAccountsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminAccountsRetrieve>>> = ({ signal }) => drfadminAccountsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminAccountsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountsRetrieve>>>
export type DrfadminAccountsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminAccountsRetrieve<TData = Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminAccountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminAccountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminAccountsRetrieve<TData = Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminAccountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminAccountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminAccountsRetrieve<TData = Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminAccountsRetrieve<TData = Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminAccountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminAccountsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminAccountsUpdate = (
    id: number,
    adminAccountRequest: AdminAccountRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminAccount>(
      {url: `/drfadmin/accounts/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminAccountRequest, signal
    },
      options);
    }




export const getDrfadminAccountsUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsUpdate>>, TError,{id: number;data: AdminAccountRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsUpdate>>, TError,{id: number;data: AdminAccountRequest}, TContext> => {

const mutationKey = ['drfadminAccountsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminAccountsUpdate>>, {id: number;data: AdminAccountRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminAccountsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminAccountsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountsUpdate>>>
    export type DrfadminAccountsUpdateMutationBody = AdminAccountRequest
    export type DrfadminAccountsUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminAccountsUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsUpdate>>, TError,{id: number;data: AdminAccountRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminAccountsUpdate>>,
        TError,
        {id: number;data: AdminAccountRequest},
        TContext
      > => {
      return useMutation(getDrfadminAccountsUpdateMutationOptions(options), queryClient);
    }
    export const drfadminAccountsPartialUpdate = (
    id: number,
    patchedAdminAccountRequest?: PatchedAdminAccountRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminAccount>(
      {url: `/drfadmin/accounts/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminAccountRequest, signal
    },
      options);
    }




export const getDrfadminAccountsPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsPartialUpdate>>, TError,{id: number;data?: PatchedAdminAccountRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsPartialUpdate>>, TError,{id: number;data?: PatchedAdminAccountRequest}, TContext> => {

const mutationKey = ['drfadminAccountsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminAccountsPartialUpdate>>, {id: number;data?: PatchedAdminAccountRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminAccountsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminAccountsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountsPartialUpdate>>>
    export type DrfadminAccountsPartialUpdateMutationBody = PatchedAdminAccountRequest | undefined
    export type DrfadminAccountsPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminAccountsPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsPartialUpdate>>, TError,{id: number;data?: PatchedAdminAccountRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminAccountsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminAccountRequest},
        TContext
      > => {
      return useMutation(getDrfadminAccountsPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminAccountsDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/accounts/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminAccountsDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminAccountsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminAccountsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminAccountsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminAccountsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminAccountsDestroy>>>

    export type DrfadminAccountsDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminAccountsDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAccountsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminAccountsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminAccountsDestroyMutationOptions(options), queryClient);
    }
    export const drfadminAdvanceDayCreate = (
    advanceDayRequest: AdvanceDayRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdvanceDay>(
      {url: `/drfadmin/advance-day`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: advanceDayRequest, signal
    },
      options);
    }




export const getDrfadminAdvanceDayCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAdvanceDayCreate>>, TError,{data: AdvanceDayRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminAdvanceDayCreate>>, TError,{data: AdvanceDayRequest}, TContext> => {

const mutationKey = ['drfadminAdvanceDayCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminAdvanceDayCreate>>, {data: AdvanceDayRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminAdvanceDayCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminAdvanceDayCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminAdvanceDayCreate>>>
    export type DrfadminAdvanceDayCreateMutationBody = AdvanceDayRequest
    export type DrfadminAdvanceDayCreateMutationError = ErrorType<ApiError>

    export const useDrfadminAdvanceDayCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminAdvanceDayCreate>>, TError,{data: AdvanceDayRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminAdvanceDayCreate>>,
        TError,
        {data: AdvanceDayRequest},
        TContext
      > => {
      return useMutation(getDrfadminAdvanceDayCreateMutationOptions(options), queryClient);
    }
    export const drfadminArticlesList = (
    params?: DrfadminArticlesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminArticleList>(
      {url: `/drfadmin/articles/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminArticlesListQueryKey = (params?: DrfadminArticlesListParams,) => {
    return [
    `/drfadmin/articles/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminArticlesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminArticlesList>>, TError = ErrorType<ApiError>>(params?: DrfadminArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminArticlesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminArticlesList>>> = ({ signal }) => drfadminArticlesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminArticlesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminArticlesList>>>
export type DrfadminArticlesListQueryError = ErrorType<ApiError>


export function useDrfadminArticlesList<TData = Awaited<ReturnType<typeof drfadminArticlesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminArticlesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminArticlesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminArticlesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminArticlesList<TData = Awaited<ReturnType<typeof drfadminArticlesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminArticlesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminArticlesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminArticlesList<TData = Awaited<ReturnType<typeof drfadminArticlesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminArticlesList<TData = Awaited<ReturnType<typeof drfadminArticlesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminArticlesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminArticlesCreate = (
    adminArticleRequest: AdminArticleRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminArticle>(
      {url: `/drfadmin/articles/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminArticleRequest, signal
    },
      options);
    }




export const getDrfadminArticlesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesCreate>>, TError,{data: AdminArticleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesCreate>>, TError,{data: AdminArticleRequest}, TContext> => {

const mutationKey = ['drfadminArticlesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminArticlesCreate>>, {data: AdminArticleRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminArticlesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminArticlesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminArticlesCreate>>>
    export type DrfadminArticlesCreateMutationBody = AdminArticleRequest
    export type DrfadminArticlesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminArticlesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesCreate>>, TError,{data: AdminArticleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminArticlesCreate>>,
        TError,
        {data: AdminArticleRequest},
        TContext
      > => {
      return useMutation(getDrfadminArticlesCreateMutationOptions(options), queryClient);
    }
    export const drfadminArticlesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminArticle>(
      {url: `/drfadmin/articles/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminArticlesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/articles/${id}/`
    ] as const;
    }


export const getDrfadminArticlesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminArticlesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminArticlesRetrieve>>> = ({ signal }) => drfadminArticlesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminArticlesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminArticlesRetrieve>>>
export type DrfadminArticlesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminArticlesRetrieve<TData = Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminArticlesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminArticlesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminArticlesRetrieve<TData = Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminArticlesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminArticlesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminArticlesRetrieve<TData = Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminArticlesRetrieve<TData = Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminArticlesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminArticlesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminArticlesUpdate = (
    id: number,
    adminArticleRequest: AdminArticleRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminArticle>(
      {url: `/drfadmin/articles/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminArticleRequest, signal
    },
      options);
    }




export const getDrfadminArticlesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesUpdate>>, TError,{id: number;data: AdminArticleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesUpdate>>, TError,{id: number;data: AdminArticleRequest}, TContext> => {

const mutationKey = ['drfadminArticlesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminArticlesUpdate>>, {id: number;data: AdminArticleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminArticlesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminArticlesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminArticlesUpdate>>>
    export type DrfadminArticlesUpdateMutationBody = AdminArticleRequest
    export type DrfadminArticlesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminArticlesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesUpdate>>, TError,{id: number;data: AdminArticleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminArticlesUpdate>>,
        TError,
        {id: number;data: AdminArticleRequest},
        TContext
      > => {
      return useMutation(getDrfadminArticlesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminArticlesPartialUpdate = (
    id: number,
    patchedAdminArticleRequest?: PatchedAdminArticleRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminArticle>(
      {url: `/drfadmin/articles/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminArticleRequest, signal
    },
      options);
    }




export const getDrfadminArticlesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesPartialUpdate>>, TError,{id: number;data?: PatchedAdminArticleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesPartialUpdate>>, TError,{id: number;data?: PatchedAdminArticleRequest}, TContext> => {

const mutationKey = ['drfadminArticlesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminArticlesPartialUpdate>>, {id: number;data?: PatchedAdminArticleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminArticlesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminArticlesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminArticlesPartialUpdate>>>
    export type DrfadminArticlesPartialUpdateMutationBody = PatchedAdminArticleRequest | undefined
    export type DrfadminArticlesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminArticlesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesPartialUpdate>>, TError,{id: number;data?: PatchedAdminArticleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminArticlesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminArticleRequest},
        TContext
      > => {
      return useMutation(getDrfadminArticlesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminArticlesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/articles/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminArticlesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminArticlesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminArticlesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminArticlesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminArticlesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminArticlesDestroy>>>

    export type DrfadminArticlesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminArticlesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminArticlesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminArticlesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminArticlesDestroyMutationOptions(options), queryClient);
    }
    export const drfadminBadgeAwardsList = (
    params?: DrfadminBadgeAwardsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminBadgeAwardList>(
      {url: `/drfadmin/badge-awards/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminBadgeAwardsListQueryKey = (params?: DrfadminBadgeAwardsListParams,) => {
    return [
    `/drfadmin/badge-awards/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminBadgeAwardsListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError = ErrorType<ApiError>>(params?: DrfadminBadgeAwardsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminBadgeAwardsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminBadgeAwardsList>>> = ({ signal }) => drfadminBadgeAwardsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminBadgeAwardsListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgeAwardsList>>>
export type DrfadminBadgeAwardsListQueryError = ErrorType<ApiError>


export function useDrfadminBadgeAwardsList<TData = Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminBadgeAwardsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminBadgeAwardsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminBadgeAwardsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminBadgeAwardsList<TData = Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminBadgeAwardsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminBadgeAwardsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminBadgeAwardsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminBadgeAwardsList<TData = Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminBadgeAwardsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminBadgeAwardsList<TData = Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminBadgeAwardsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminBadgeAwardsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminBadgeAwardsCreate = (
    adminBadgeAwardRequest: AdminBadgeAwardRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminBadgeAward>(
      {url: `/drfadmin/badge-awards/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminBadgeAwardRequest, signal
    },
      options);
    }




export const getDrfadminBadgeAwardsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsCreate>>, TError,{data: AdminBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsCreate>>, TError,{data: AdminBadgeAwardRequest}, TContext> => {

const mutationKey = ['drfadminBadgeAwardsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminBadgeAwardsCreate>>, {data: AdminBadgeAwardRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminBadgeAwardsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminBadgeAwardsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgeAwardsCreate>>>
    export type DrfadminBadgeAwardsCreateMutationBody = AdminBadgeAwardRequest
    export type DrfadminBadgeAwardsCreateMutationError = ErrorType<ApiError>

    export const useDrfadminBadgeAwardsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsCreate>>, TError,{data: AdminBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminBadgeAwardsCreate>>,
        TError,
        {data: AdminBadgeAwardRequest},
        TContext
      > => {
      return useMutation(getDrfadminBadgeAwardsCreateMutationOptions(options), queryClient);
    }
    export const drfadminBadgeAwardsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminBadgeAward>(
      {url: `/drfadmin/badge-awards/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminBadgeAwardsRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/badge-awards/${id}/`
    ] as const;
    }


export const getDrfadminBadgeAwardsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminBadgeAwardsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>> = ({ signal }) => drfadminBadgeAwardsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminBadgeAwardsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>>
export type DrfadminBadgeAwardsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminBadgeAwardsRetrieve<TData = Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminBadgeAwardsRetrieve<TData = Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminBadgeAwardsRetrieve<TData = Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminBadgeAwardsRetrieve<TData = Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminBadgeAwardsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminBadgeAwardsUpdate = (
    id: number,
    adminBadgeAwardRequest: AdminBadgeAwardRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminBadgeAward>(
      {url: `/drfadmin/badge-awards/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminBadgeAwardRequest, signal
    },
      options);
    }




export const getDrfadminBadgeAwardsUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsUpdate>>, TError,{id: number;data: AdminBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsUpdate>>, TError,{id: number;data: AdminBadgeAwardRequest}, TContext> => {

const mutationKey = ['drfadminBadgeAwardsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminBadgeAwardsUpdate>>, {id: number;data: AdminBadgeAwardRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminBadgeAwardsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminBadgeAwardsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgeAwardsUpdate>>>
    export type DrfadminBadgeAwardsUpdateMutationBody = AdminBadgeAwardRequest
    export type DrfadminBadgeAwardsUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminBadgeAwardsUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsUpdate>>, TError,{id: number;data: AdminBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminBadgeAwardsUpdate>>,
        TError,
        {id: number;data: AdminBadgeAwardRequest},
        TContext
      > => {
      return useMutation(getDrfadminBadgeAwardsUpdateMutationOptions(options), queryClient);
    }
    export const drfadminBadgeAwardsPartialUpdate = (
    id: number,
    patchedAdminBadgeAwardRequest?: PatchedAdminBadgeAwardRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminBadgeAward>(
      {url: `/drfadmin/badge-awards/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminBadgeAwardRequest, signal
    },
      options);
    }




export const getDrfadminBadgeAwardsPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsPartialUpdate>>, TError,{id: number;data?: PatchedAdminBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsPartialUpdate>>, TError,{id: number;data?: PatchedAdminBadgeAwardRequest}, TContext> => {

const mutationKey = ['drfadminBadgeAwardsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminBadgeAwardsPartialUpdate>>, {id: number;data?: PatchedAdminBadgeAwardRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminBadgeAwardsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminBadgeAwardsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgeAwardsPartialUpdate>>>
    export type DrfadminBadgeAwardsPartialUpdateMutationBody = PatchedAdminBadgeAwardRequest | undefined
    export type DrfadminBadgeAwardsPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminBadgeAwardsPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsPartialUpdate>>, TError,{id: number;data?: PatchedAdminBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminBadgeAwardsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminBadgeAwardRequest},
        TContext
      > => {
      return useMutation(getDrfadminBadgeAwardsPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminBadgeAwardsDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/badge-awards/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminBadgeAwardsDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminBadgeAwardsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminBadgeAwardsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminBadgeAwardsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminBadgeAwardsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgeAwardsDestroy>>>

    export type DrfadminBadgeAwardsDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminBadgeAwardsDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgeAwardsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminBadgeAwardsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminBadgeAwardsDestroyMutationOptions(options), queryClient);
    }
    export const drfadminBadgesList = (
    params?: DrfadminBadgesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminBadgeList>(
      {url: `/drfadmin/badges/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminBadgesListQueryKey = (params?: DrfadminBadgesListParams,) => {
    return [
    `/drfadmin/badges/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminBadgesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminBadgesList>>, TError = ErrorType<ApiError>>(params?: DrfadminBadgesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminBadgesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminBadgesList>>> = ({ signal }) => drfadminBadgesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminBadgesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgesList>>>
export type DrfadminBadgesListQueryError = ErrorType<ApiError>


export function useDrfadminBadgesList<TData = Awaited<ReturnType<typeof drfadminBadgesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminBadgesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminBadgesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminBadgesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminBadgesList<TData = Awaited<ReturnType<typeof drfadminBadgesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminBadgesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminBadgesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminBadgesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminBadgesList<TData = Awaited<ReturnType<typeof drfadminBadgesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminBadgesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminBadgesList<TData = Awaited<ReturnType<typeof drfadminBadgesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminBadgesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminBadgesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminBadgesCreate = (
    adminBadgeRequest: AdminBadgeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminBadge>(
      {url: `/drfadmin/badges/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminBadgeRequest, signal
    },
      options);
    }




export const getDrfadminBadgesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesCreate>>, TError,{data: AdminBadgeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesCreate>>, TError,{data: AdminBadgeRequest}, TContext> => {

const mutationKey = ['drfadminBadgesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminBadgesCreate>>, {data: AdminBadgeRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminBadgesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminBadgesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgesCreate>>>
    export type DrfadminBadgesCreateMutationBody = AdminBadgeRequest
    export type DrfadminBadgesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminBadgesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesCreate>>, TError,{data: AdminBadgeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminBadgesCreate>>,
        TError,
        {data: AdminBadgeRequest},
        TContext
      > => {
      return useMutation(getDrfadminBadgesCreateMutationOptions(options), queryClient);
    }
    export const drfadminBadgesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminBadge>(
      {url: `/drfadmin/badges/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminBadgesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/badges/${id}/`
    ] as const;
    }


export const getDrfadminBadgesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminBadgesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminBadgesRetrieve>>> = ({ signal }) => drfadminBadgesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminBadgesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgesRetrieve>>>
export type DrfadminBadgesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminBadgesRetrieve<TData = Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminBadgesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminBadgesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminBadgesRetrieve<TData = Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminBadgesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminBadgesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminBadgesRetrieve<TData = Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminBadgesRetrieve<TData = Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminBadgesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminBadgesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminBadgesUpdate = (
    id: number,
    adminBadgeRequest: AdminBadgeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminBadge>(
      {url: `/drfadmin/badges/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminBadgeRequest, signal
    },
      options);
    }




export const getDrfadminBadgesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesUpdate>>, TError,{id: number;data: AdminBadgeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesUpdate>>, TError,{id: number;data: AdminBadgeRequest}, TContext> => {

const mutationKey = ['drfadminBadgesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminBadgesUpdate>>, {id: number;data: AdminBadgeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminBadgesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminBadgesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgesUpdate>>>
    export type DrfadminBadgesUpdateMutationBody = AdminBadgeRequest
    export type DrfadminBadgesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminBadgesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesUpdate>>, TError,{id: number;data: AdminBadgeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminBadgesUpdate>>,
        TError,
        {id: number;data: AdminBadgeRequest},
        TContext
      > => {
      return useMutation(getDrfadminBadgesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminBadgesPartialUpdate = (
    id: number,
    patchedAdminBadgeRequest?: PatchedAdminBadgeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminBadge>(
      {url: `/drfadmin/badges/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminBadgeRequest, signal
    },
      options);
    }




export const getDrfadminBadgesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesPartialUpdate>>, TError,{id: number;data?: PatchedAdminBadgeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesPartialUpdate>>, TError,{id: number;data?: PatchedAdminBadgeRequest}, TContext> => {

const mutationKey = ['drfadminBadgesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminBadgesPartialUpdate>>, {id: number;data?: PatchedAdminBadgeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminBadgesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminBadgesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgesPartialUpdate>>>
    export type DrfadminBadgesPartialUpdateMutationBody = PatchedAdminBadgeRequest | undefined
    export type DrfadminBadgesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminBadgesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesPartialUpdate>>, TError,{id: number;data?: PatchedAdminBadgeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminBadgesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminBadgeRequest},
        TContext
      > => {
      return useMutation(getDrfadminBadgesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminBadgesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/badges/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminBadgesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminBadgesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminBadgesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminBadgesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminBadgesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminBadgesDestroy>>>

    export type DrfadminBadgesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminBadgesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminBadgesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminBadgesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminBadgesDestroyMutationOptions(options), queryClient);
    }
    /**
 * Admin ViewSet for managing ClassName instances (game sessions/classes).
 *
 * A ClassName represents a game session or class period where students play
 * the geopolitical strategy game. Each ClassName contains multiple nations,
 * users, and game state.
 *
 * Provides CRUD operations for classes, allowing admins to:
 * - List all classes in their account
 * - Create new classes with unique codes
 * - Update class settings (name, borders_enabled, timestamps)
 * - Delete classes (except demo classes)
 *
 * Features:
 * - Filtering by is_demo_class flag
 * - Ordering by name, created_at, or id
 * - Automatic code generation for new classes
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of demo classes (used for testing/demos)
 * - Scoped to current account only
 *
 * Performance:
 * - Uses base AdminViewSet queryset (filtered by account_id)
 * - No additional query optimization needed (simple model)
 */
export const drfadminClassesList = (
    params?: DrfadminClassesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminClassNameList>(
      {url: `/drfadmin/classes/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminClassesListQueryKey = (params?: DrfadminClassesListParams,) => {
    return [
    `/drfadmin/classes/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminClassesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminClassesList>>, TError = ErrorType<ApiError>>(params?: DrfadminClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminClassesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminClassesList>>> = ({ signal }) => drfadminClassesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminClassesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminClassesList>>>
export type DrfadminClassesListQueryError = ErrorType<ApiError>


export function useDrfadminClassesList<TData = Awaited<ReturnType<typeof drfadminClassesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminClassesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminClassesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminClassesList<TData = Awaited<ReturnType<typeof drfadminClassesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminClassesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminClassesList<TData = Awaited<ReturnType<typeof drfadminClassesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminClassesList<TData = Awaited<ReturnType<typeof drfadminClassesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminClassesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Admin ViewSet for managing ClassName instances (game sessions/classes).
 *
 * A ClassName represents a game session or class period where students play
 * the geopolitical strategy game. Each ClassName contains multiple nations,
 * users, and game state.
 *
 * Provides CRUD operations for classes, allowing admins to:
 * - List all classes in their account
 * - Create new classes with unique codes
 * - Update class settings (name, borders_enabled, timestamps)
 * - Delete classes (except demo classes)
 *
 * Features:
 * - Filtering by is_demo_class flag
 * - Ordering by name, created_at, or id
 * - Automatic code generation for new classes
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of demo classes (used for testing/demos)
 * - Scoped to current account only
 *
 * Performance:
 * - Uses base AdminViewSet queryset (filtered by account_id)
 * - No additional query optimization needed (simple model)
 */
export const drfadminClassesCreate = (
    adminClassNameRequest: AdminClassNameRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminClassName>(
      {url: `/drfadmin/classes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminClassNameRequest, signal
    },
      options);
    }




export const getDrfadminClassesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesCreate>>, TError,{data: AdminClassNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesCreate>>, TError,{data: AdminClassNameRequest}, TContext> => {

const mutationKey = ['drfadminClassesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminClassesCreate>>, {data: AdminClassNameRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminClassesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminClassesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminClassesCreate>>>
    export type DrfadminClassesCreateMutationBody = AdminClassNameRequest
    export type DrfadminClassesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminClassesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesCreate>>, TError,{data: AdminClassNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminClassesCreate>>,
        TError,
        {data: AdminClassNameRequest},
        TContext
      > => {
      return useMutation(getDrfadminClassesCreateMutationOptions(options), queryClient);
    }
    /**
 * Admin ViewSet for managing ClassName instances (game sessions/classes).
 *
 * A ClassName represents a game session or class period where students play
 * the geopolitical strategy game. Each ClassName contains multiple nations,
 * users, and game state.
 *
 * Provides CRUD operations for classes, allowing admins to:
 * - List all classes in their account
 * - Create new classes with unique codes
 * - Update class settings (name, borders_enabled, timestamps)
 * - Delete classes (except demo classes)
 *
 * Features:
 * - Filtering by is_demo_class flag
 * - Ordering by name, created_at, or id
 * - Automatic code generation for new classes
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of demo classes (used for testing/demos)
 * - Scoped to current account only
 *
 * Performance:
 * - Uses base AdminViewSet queryset (filtered by account_id)
 * - No additional query optimization needed (simple model)
 */
export const drfadminClassesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminClassName>(
      {url: `/drfadmin/classes/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminClassesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/classes/${id}/`
    ] as const;
    }


export const getDrfadminClassesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminClassesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminClassesRetrieve>>> = ({ signal }) => drfadminClassesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminClassesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminClassesRetrieve>>>
export type DrfadminClassesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminClassesRetrieve<TData = Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminClassesRetrieve<TData = Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminClassesRetrieve<TData = Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminClassesRetrieve<TData = Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminClassesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Admin ViewSet for managing ClassName instances (game sessions/classes).
 *
 * A ClassName represents a game session or class period where students play
 * the geopolitical strategy game. Each ClassName contains multiple nations,
 * users, and game state.
 *
 * Provides CRUD operations for classes, allowing admins to:
 * - List all classes in their account
 * - Create new classes with unique codes
 * - Update class settings (name, borders_enabled, timestamps)
 * - Delete classes (except demo classes)
 *
 * Features:
 * - Filtering by is_demo_class flag
 * - Ordering by name, created_at, or id
 * - Automatic code generation for new classes
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of demo classes (used for testing/demos)
 * - Scoped to current account only
 *
 * Performance:
 * - Uses base AdminViewSet queryset (filtered by account_id)
 * - No additional query optimization needed (simple model)
 */
export const drfadminClassesUpdate = (
    id: number,
    adminClassNameRequest: AdminClassNameRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminClassName>(
      {url: `/drfadmin/classes/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminClassNameRequest, signal
    },
      options);
    }




export const getDrfadminClassesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesUpdate>>, TError,{id: number;data: AdminClassNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesUpdate>>, TError,{id: number;data: AdminClassNameRequest}, TContext> => {

const mutationKey = ['drfadminClassesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminClassesUpdate>>, {id: number;data: AdminClassNameRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminClassesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminClassesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminClassesUpdate>>>
    export type DrfadminClassesUpdateMutationBody = AdminClassNameRequest
    export type DrfadminClassesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminClassesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesUpdate>>, TError,{id: number;data: AdminClassNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminClassesUpdate>>,
        TError,
        {id: number;data: AdminClassNameRequest},
        TContext
      > => {
      return useMutation(getDrfadminClassesUpdateMutationOptions(options), queryClient);
    }
    /**
 * Admin ViewSet for managing ClassName instances (game sessions/classes).
 *
 * A ClassName represents a game session or class period where students play
 * the geopolitical strategy game. Each ClassName contains multiple nations,
 * users, and game state.
 *
 * Provides CRUD operations for classes, allowing admins to:
 * - List all classes in their account
 * - Create new classes with unique codes
 * - Update class settings (name, borders_enabled, timestamps)
 * - Delete classes (except demo classes)
 *
 * Features:
 * - Filtering by is_demo_class flag
 * - Ordering by name, created_at, or id
 * - Automatic code generation for new classes
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of demo classes (used for testing/demos)
 * - Scoped to current account only
 *
 * Performance:
 * - Uses base AdminViewSet queryset (filtered by account_id)
 * - No additional query optimization needed (simple model)
 */
export const drfadminClassesPartialUpdate = (
    id: number,
    patchedAdminClassNameRequest?: PatchedAdminClassNameRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminClassName>(
      {url: `/drfadmin/classes/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminClassNameRequest, signal
    },
      options);
    }




export const getDrfadminClassesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesPartialUpdate>>, TError,{id: number;data?: PatchedAdminClassNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesPartialUpdate>>, TError,{id: number;data?: PatchedAdminClassNameRequest}, TContext> => {

const mutationKey = ['drfadminClassesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminClassesPartialUpdate>>, {id: number;data?: PatchedAdminClassNameRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminClassesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminClassesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminClassesPartialUpdate>>>
    export type DrfadminClassesPartialUpdateMutationBody = PatchedAdminClassNameRequest | undefined
    export type DrfadminClassesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminClassesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesPartialUpdate>>, TError,{id: number;data?: PatchedAdminClassNameRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminClassesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminClassNameRequest},
        TContext
      > => {
      return useMutation(getDrfadminClassesPartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * Delete a ClassName.
 *
 * Prevents deletion of demo classes, which are special classes used
 * for demonstrations and testing purposes.
 *
 * Returns:
 *     403 if attempting to delete a demo class
 *     200 with success message on successful deletion
 */
export const drfadminClassesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/classes/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminClassesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminClassesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminClassesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminClassesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminClassesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminClassesDestroy>>>

    export type DrfadminClassesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminClassesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminClassesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminClassesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminClassesDestroyMutationOptions(options), queryClient);
    }
    export const drfadminCommentsList = (
    params?: DrfadminCommentsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminCommentList>(
      {url: `/drfadmin/comments/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminCommentsListQueryKey = (params?: DrfadminCommentsListParams,) => {
    return [
    `/drfadmin/comments/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminCommentsListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminCommentsList>>, TError = ErrorType<ApiError>>(params?: DrfadminCommentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminCommentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminCommentsList>>> = ({ signal }) => drfadminCommentsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminCommentsListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminCommentsList>>>
export type DrfadminCommentsListQueryError = ErrorType<ApiError>


export function useDrfadminCommentsList<TData = Awaited<ReturnType<typeof drfadminCommentsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminCommentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminCommentsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminCommentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminCommentsList<TData = Awaited<ReturnType<typeof drfadminCommentsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminCommentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminCommentsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminCommentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminCommentsList<TData = Awaited<ReturnType<typeof drfadminCommentsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminCommentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminCommentsList<TData = Awaited<ReturnType<typeof drfadminCommentsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminCommentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminCommentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminCommentsCreate = (
    adminCommentRequest: AdminCommentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminComment>(
      {url: `/drfadmin/comments/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCommentRequest, signal
    },
      options);
    }




export const getDrfadminCommentsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsCreate>>, TError,{data: AdminCommentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsCreate>>, TError,{data: AdminCommentRequest}, TContext> => {

const mutationKey = ['drfadminCommentsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminCommentsCreate>>, {data: AdminCommentRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminCommentsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminCommentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminCommentsCreate>>>
    export type DrfadminCommentsCreateMutationBody = AdminCommentRequest
    export type DrfadminCommentsCreateMutationError = ErrorType<ApiError>

    export const useDrfadminCommentsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsCreate>>, TError,{data: AdminCommentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminCommentsCreate>>,
        TError,
        {data: AdminCommentRequest},
        TContext
      > => {
      return useMutation(getDrfadminCommentsCreateMutationOptions(options), queryClient);
    }
    export const drfadminCommentsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminComment>(
      {url: `/drfadmin/comments/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminCommentsRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/comments/${id}/`
    ] as const;
    }


export const getDrfadminCommentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminCommentsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminCommentsRetrieve>>> = ({ signal }) => drfadminCommentsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminCommentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminCommentsRetrieve>>>
export type DrfadminCommentsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminCommentsRetrieve<TData = Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminCommentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminCommentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminCommentsRetrieve<TData = Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminCommentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminCommentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminCommentsRetrieve<TData = Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminCommentsRetrieve<TData = Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminCommentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminCommentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminCommentsUpdate = (
    id: number,
    adminCommentRequest: AdminCommentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminComment>(
      {url: `/drfadmin/comments/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminCommentRequest, signal
    },
      options);
    }




export const getDrfadminCommentsUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsUpdate>>, TError,{id: number;data: AdminCommentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsUpdate>>, TError,{id: number;data: AdminCommentRequest}, TContext> => {

const mutationKey = ['drfadminCommentsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminCommentsUpdate>>, {id: number;data: AdminCommentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminCommentsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminCommentsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminCommentsUpdate>>>
    export type DrfadminCommentsUpdateMutationBody = AdminCommentRequest
    export type DrfadminCommentsUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminCommentsUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsUpdate>>, TError,{id: number;data: AdminCommentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminCommentsUpdate>>,
        TError,
        {id: number;data: AdminCommentRequest},
        TContext
      > => {
      return useMutation(getDrfadminCommentsUpdateMutationOptions(options), queryClient);
    }
    export const drfadminCommentsPartialUpdate = (
    id: number,
    patchedAdminCommentRequest?: PatchedAdminCommentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminComment>(
      {url: `/drfadmin/comments/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminCommentRequest, signal
    },
      options);
    }




export const getDrfadminCommentsPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsPartialUpdate>>, TError,{id: number;data?: PatchedAdminCommentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsPartialUpdate>>, TError,{id: number;data?: PatchedAdminCommentRequest}, TContext> => {

const mutationKey = ['drfadminCommentsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminCommentsPartialUpdate>>, {id: number;data?: PatchedAdminCommentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminCommentsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminCommentsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminCommentsPartialUpdate>>>
    export type DrfadminCommentsPartialUpdateMutationBody = PatchedAdminCommentRequest | undefined
    export type DrfadminCommentsPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminCommentsPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsPartialUpdate>>, TError,{id: number;data?: PatchedAdminCommentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminCommentsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminCommentRequest},
        TContext
      > => {
      return useMutation(getDrfadminCommentsPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminCommentsDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/comments/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminCommentsDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminCommentsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminCommentsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminCommentsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminCommentsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminCommentsDestroy>>>

    export type DrfadminCommentsDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminCommentsDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminCommentsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminCommentsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminCommentsDestroyMutationOptions(options), queryClient);
    }
    /**
 * Get Google Classroom courses for the authenticated teacher.
 *
 * Returns a list of courses with the following structure:
 * {
 *     "courses": [
 *         {
 *             "id": "123456",
 *             "name": "Math 101",
 *             "section": "Period 1",
 *             "descriptionHeading": "Introduction to Mathematics",
 *             "courseState": "ACTIVE",
 *             "alternateLink": "https://classroom.google.com/c/...",
 *             "teacherFolder": {...},
 *             "courseGroupEmail": "math101@classroom.google.com",
 *             ...
 *         }
 *     ],
 *     "nextPageToken": "token_for_next_page"
 * }
 */
export const drfadminGoogleClassroomCoursesRetrieve = (
    params?: DrfadminGoogleClassroomCoursesRetrieveParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GoogleClassroomCoursesResponse>(
      {url: `/drfadmin/google-classroom-courses`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminGoogleClassroomCoursesRetrieveQueryKey = (params?: DrfadminGoogleClassroomCoursesRetrieveParams,) => {
    return [
    `/drfadmin/google-classroom-courses`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminGoogleClassroomCoursesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError = ErrorType<ApiError>>(params?: DrfadminGoogleClassroomCoursesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminGoogleClassroomCoursesRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>> = ({ signal }) => drfadminGoogleClassroomCoursesRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminGoogleClassroomCoursesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>>
export type DrfadminGoogleClassroomCoursesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminGoogleClassroomCoursesRetrieve<TData = Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminGoogleClassroomCoursesRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminGoogleClassroomCoursesRetrieve<TData = Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError = ErrorType<ApiError>>(
 params?: DrfadminGoogleClassroomCoursesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminGoogleClassroomCoursesRetrieve<TData = Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError = ErrorType<ApiError>>(
 params?: DrfadminGoogleClassroomCoursesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminGoogleClassroomCoursesRetrieve<TData = Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError = ErrorType<ApiError>>(
 params?: DrfadminGoogleClassroomCoursesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomCoursesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminGoogleClassroomCoursesRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get students for a specific Google Classroom course.
 *
 * Returns a list of students with the following structure:
 * {
 *     "students": [
 *         {
 *             "courseId": "123456",
 *             "userId": "987654321",
 *             "profile": {
 *                 "id": "987654321",
 *                 "name": {
 *                     "givenName": "John",
 *                     "familyName": "Doe",
 *                     "fullName": "John Doe"
 *                 },
 *                 "emailAddress": "john.doe@school.edu",
 *                 "photoUrl": "https://lh3.googleusercontent.com/..."
 *             }
 *         }
 *     ],
 *     "nextPageToken": "token_for_next_page"
 * }
 */
export const drfadminGoogleClassroomStudentsRetrieve = (
    params: DrfadminGoogleClassroomStudentsRetrieveParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GoogleClassroomStudentsResponse>(
      {url: `/drfadmin/google-classroom-students`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminGoogleClassroomStudentsRetrieveQueryKey = (params?: DrfadminGoogleClassroomStudentsRetrieveParams,) => {
    return [
    `/drfadmin/google-classroom-students`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminGoogleClassroomStudentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError = ErrorType<ApiError>>(params: DrfadminGoogleClassroomStudentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminGoogleClassroomStudentsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>> = ({ signal }) => drfadminGoogleClassroomStudentsRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminGoogleClassroomStudentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>>
export type DrfadminGoogleClassroomStudentsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminGoogleClassroomStudentsRetrieve<TData = Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError = ErrorType<ApiError>>(
 params: DrfadminGoogleClassroomStudentsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminGoogleClassroomStudentsRetrieve<TData = Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError = ErrorType<ApiError>>(
 params: DrfadminGoogleClassroomStudentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminGoogleClassroomStudentsRetrieve<TData = Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError = ErrorType<ApiError>>(
 params: DrfadminGoogleClassroomStudentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminGoogleClassroomStudentsRetrieve<TData = Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError = ErrorType<ApiError>>(
 params: DrfadminGoogleClassroomStudentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminGoogleClassroomStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminGoogleClassroomStudentsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminItemsList = (
    params?: DrfadminItemsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminItemList>(
      {url: `/drfadmin/items/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminItemsListQueryKey = (params?: DrfadminItemsListParams,) => {
    return [
    `/drfadmin/items/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminItemsListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminItemsList>>, TError = ErrorType<ApiError>>(params?: DrfadminItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminItemsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminItemsList>>> = ({ signal }) => drfadminItemsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminItemsListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminItemsList>>>
export type DrfadminItemsListQueryError = ErrorType<ApiError>


export function useDrfadminItemsList<TData = Awaited<ReturnType<typeof drfadminItemsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminItemsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminItemsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminItemsList<TData = Awaited<ReturnType<typeof drfadminItemsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminItemsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminItemsList<TData = Awaited<ReturnType<typeof drfadminItemsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminItemsList<TData = Awaited<ReturnType<typeof drfadminItemsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminItemsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminItemsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminItemsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminItem>(
      {url: `/drfadmin/items/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminItemsRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/items/${id}/`
    ] as const;
    }


export const getDrfadminItemsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminItemsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminItemsRetrieve>>> = ({ signal }) => drfadminItemsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminItemsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminItemsRetrieve>>>
export type DrfadminItemsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminItemsRetrieve<TData = Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminItemsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminItemsRetrieve<TData = Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminItemsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminItemsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminItemsRetrieve<TData = Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminItemsRetrieve<TData = Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminItemsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminItemsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminMilitaryAlliancesList = (
    params?: DrfadminMilitaryAlliancesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedNewMilitaryAllianceList>(
      {url: `/drfadmin/military-alliances/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminMilitaryAlliancesListQueryKey = (params?: DrfadminMilitaryAlliancesListParams,) => {
    return [
    `/drfadmin/military-alliances/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminMilitaryAlliancesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError = ErrorType<ApiError>>(params?: DrfadminMilitaryAlliancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminMilitaryAlliancesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>> = ({ signal }) => drfadminMilitaryAlliancesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminMilitaryAlliancesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>>
export type DrfadminMilitaryAlliancesListQueryError = ErrorType<ApiError>


export function useDrfadminMilitaryAlliancesList<TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminMilitaryAlliancesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminMilitaryAlliancesList<TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminMilitaryAlliancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminMilitaryAlliancesList<TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminMilitaryAlliancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminMilitaryAlliancesList<TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminMilitaryAlliancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminMilitaryAlliancesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminMilitaryAlliancesCreate = (
    newMilitaryAllianceRequest: NewMilitaryAllianceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewMilitaryAlliance>(
      {url: `/drfadmin/military-alliances/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newMilitaryAllianceRequest, signal
    },
      options);
    }




export const getDrfadminMilitaryAlliancesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesCreate>>, TError,{data: NewMilitaryAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesCreate>>, TError,{data: NewMilitaryAllianceRequest}, TContext> => {

const mutationKey = ['drfadminMilitaryAlliancesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminMilitaryAlliancesCreate>>, {data: NewMilitaryAllianceRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminMilitaryAlliancesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminMilitaryAlliancesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminMilitaryAlliancesCreate>>>
    export type DrfadminMilitaryAlliancesCreateMutationBody = NewMilitaryAllianceRequest
    export type DrfadminMilitaryAlliancesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminMilitaryAlliancesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesCreate>>, TError,{data: NewMilitaryAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminMilitaryAlliancesCreate>>,
        TError,
        {data: NewMilitaryAllianceRequest},
        TContext
      > => {
      return useMutation(getDrfadminMilitaryAlliancesCreateMutationOptions(options), queryClient);
    }
    export const drfadminMilitaryAlliancesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewMilitaryAlliance>(
      {url: `/drfadmin/military-alliances/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminMilitaryAlliancesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/military-alliances/${id}/`
    ] as const;
    }


export const getDrfadminMilitaryAlliancesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminMilitaryAlliancesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>> = ({ signal }) => drfadminMilitaryAlliancesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminMilitaryAlliancesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>>
export type DrfadminMilitaryAlliancesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminMilitaryAlliancesRetrieve<TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminMilitaryAlliancesRetrieve<TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminMilitaryAlliancesRetrieve<TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminMilitaryAlliancesRetrieve<TData = Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminMilitaryAlliancesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminMilitaryAlliancesUpdate = (
    id: number,
    newMilitaryAllianceRequest: NewMilitaryAllianceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewMilitaryAlliance>(
      {url: `/drfadmin/military-alliances/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: newMilitaryAllianceRequest, signal
    },
      options);
    }




export const getDrfadminMilitaryAlliancesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesUpdate>>, TError,{id: number;data: NewMilitaryAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesUpdate>>, TError,{id: number;data: NewMilitaryAllianceRequest}, TContext> => {

const mutationKey = ['drfadminMilitaryAlliancesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminMilitaryAlliancesUpdate>>, {id: number;data: NewMilitaryAllianceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminMilitaryAlliancesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminMilitaryAlliancesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminMilitaryAlliancesUpdate>>>
    export type DrfadminMilitaryAlliancesUpdateMutationBody = NewMilitaryAllianceRequest
    export type DrfadminMilitaryAlliancesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminMilitaryAlliancesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesUpdate>>, TError,{id: number;data: NewMilitaryAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminMilitaryAlliancesUpdate>>,
        TError,
        {id: number;data: NewMilitaryAllianceRequest},
        TContext
      > => {
      return useMutation(getDrfadminMilitaryAlliancesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminMilitaryAlliancesPartialUpdate = (
    id: number,
    patchedNewMilitaryAllianceRequest?: PatchedNewMilitaryAllianceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewMilitaryAlliance>(
      {url: `/drfadmin/military-alliances/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedNewMilitaryAllianceRequest, signal
    },
      options);
    }




export const getDrfadminMilitaryAlliancesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesPartialUpdate>>, TError,{id: number;data?: PatchedNewMilitaryAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesPartialUpdate>>, TError,{id: number;data?: PatchedNewMilitaryAllianceRequest}, TContext> => {

const mutationKey = ['drfadminMilitaryAlliancesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminMilitaryAlliancesPartialUpdate>>, {id: number;data?: PatchedNewMilitaryAllianceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminMilitaryAlliancesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminMilitaryAlliancesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminMilitaryAlliancesPartialUpdate>>>
    export type DrfadminMilitaryAlliancesPartialUpdateMutationBody = PatchedNewMilitaryAllianceRequest | undefined
    export type DrfadminMilitaryAlliancesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminMilitaryAlliancesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesPartialUpdate>>, TError,{id: number;data?: PatchedNewMilitaryAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminMilitaryAlliancesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedNewMilitaryAllianceRequest},
        TContext
      > => {
      return useMutation(getDrfadminMilitaryAlliancesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminMilitaryAlliancesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/military-alliances/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminMilitaryAlliancesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminMilitaryAlliancesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminMilitaryAlliancesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminMilitaryAlliancesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminMilitaryAlliancesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminMilitaryAlliancesDestroy>>>

    export type DrfadminMilitaryAlliancesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminMilitaryAlliancesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminMilitaryAlliancesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminMilitaryAlliancesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminMilitaryAlliancesDestroyMutationOptions(options), queryClient);
    }
    /**
 * Admin ViewSet for managing Nation instances (countries/territories in the game).
 *
 * Provides CRUD operations for nations, allowing admins to:
 * - List all nations in their account
 * - Create new nations with initial resource allocations
 * - Update nation details (name, flag, constitution, borders)
 * - Delete nations (except World Bank special nation)
 *
 * Features:
 * - Filtering by class_name
 * - Ordering by name, class_name, created_at, or id
 * - Resource data included in responses
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of World Bank nation (special system nation)
 * - Scoped to current account only
 *
 * Performance:
 * - Prefetches resources and resource types to avoid N+1 queries
 * - Optimized for admin list views with resource data
 */
export const drfadminNationsList = (
    params?: DrfadminNationsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminNationsList>(
      {url: `/drfadmin/nations/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminNationsListQueryKey = (params?: DrfadminNationsListParams,) => {
    return [
    `/drfadmin/nations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminNationsListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminNationsList>>, TError = ErrorType<ApiError>>(params?: DrfadminNationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminNationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminNationsList>>> = ({ signal }) => drfadminNationsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminNationsListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminNationsList>>>
export type DrfadminNationsListQueryError = ErrorType<ApiError>


export function useDrfadminNationsList<TData = Awaited<ReturnType<typeof drfadminNationsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminNationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNationsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminNationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNationsList<TData = Awaited<ReturnType<typeof drfadminNationsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminNationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNationsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminNationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNationsList<TData = Awaited<ReturnType<typeof drfadminNationsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminNationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminNationsList<TData = Awaited<ReturnType<typeof drfadminNationsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminNationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminNationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Admin ViewSet for managing Nation instances (countries/territories in the game).
 *
 * Provides CRUD operations for nations, allowing admins to:
 * - List all nations in their account
 * - Create new nations with initial resource allocations
 * - Update nation details (name, flag, constitution, borders)
 * - Delete nations (except World Bank special nation)
 *
 * Features:
 * - Filtering by class_name
 * - Ordering by name, class_name, created_at, or id
 * - Resource data included in responses
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of World Bank nation (special system nation)
 * - Scoped to current account only
 *
 * Performance:
 * - Prefetches resources and resource types to avoid N+1 queries
 * - Optimized for admin list views with resource data
 */
export const drfadminNationsCreate = (
    adminNationsRequest: AdminNationsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminNations>(
      {url: `/drfadmin/nations/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminNationsRequest, signal
    },
      options);
    }




export const getDrfadminNationsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsCreate>>, TError,{data: AdminNationsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsCreate>>, TError,{data: AdminNationsRequest}, TContext> => {

const mutationKey = ['drfadminNationsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNationsCreate>>, {data: AdminNationsRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminNationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNationsCreate>>>
    export type DrfadminNationsCreateMutationBody = AdminNationsRequest
    export type DrfadminNationsCreateMutationError = ErrorType<ApiError>

    export const useDrfadminNationsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsCreate>>, TError,{data: AdminNationsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNationsCreate>>,
        TError,
        {data: AdminNationsRequest},
        TContext
      > => {
      return useMutation(getDrfadminNationsCreateMutationOptions(options), queryClient);
    }
    /**
 * Admin ViewSet for managing Nation instances (countries/territories in the game).
 *
 * Provides CRUD operations for nations, allowing admins to:
 * - List all nations in their account
 * - Create new nations with initial resource allocations
 * - Update nation details (name, flag, constitution, borders)
 * - Delete nations (except World Bank special nation)
 *
 * Features:
 * - Filtering by class_name
 * - Ordering by name, class_name, created_at, or id
 * - Resource data included in responses
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of World Bank nation (special system nation)
 * - Scoped to current account only
 *
 * Performance:
 * - Prefetches resources and resource types to avoid N+1 queries
 * - Optimized for admin list views with resource data
 */
export const drfadminNationsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminNations>(
      {url: `/drfadmin/nations/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminNationsRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/nations/${id}/`
    ] as const;
    }


export const getDrfadminNationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminNationsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminNationsRetrieve>>> = ({ signal }) => drfadminNationsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminNationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminNationsRetrieve>>>
export type DrfadminNationsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminNationsRetrieve<TData = Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminNationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNationsRetrieve<TData = Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminNationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNationsRetrieve<TData = Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminNationsRetrieve<TData = Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminNationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Admin ViewSet for managing Nation instances (countries/territories in the game).
 *
 * Provides CRUD operations for nations, allowing admins to:
 * - List all nations in their account
 * - Create new nations with initial resource allocations
 * - Update nation details (name, flag, constitution, borders)
 * - Delete nations (except World Bank special nation)
 *
 * Features:
 * - Filtering by class_name
 * - Ordering by name, class_name, created_at, or id
 * - Resource data included in responses
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of World Bank nation (special system nation)
 * - Scoped to current account only
 *
 * Performance:
 * - Prefetches resources and resource types to avoid N+1 queries
 * - Optimized for admin list views with resource data
 */
export const drfadminNationsUpdate = (
    id: number,
    adminNationsRequest: AdminNationsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminNations>(
      {url: `/drfadmin/nations/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminNationsRequest, signal
    },
      options);
    }




export const getDrfadminNationsUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsUpdate>>, TError,{id: number;data: AdminNationsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsUpdate>>, TError,{id: number;data: AdminNationsRequest}, TContext> => {

const mutationKey = ['drfadminNationsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNationsUpdate>>, {id: number;data: AdminNationsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminNationsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNationsUpdate>>>
    export type DrfadminNationsUpdateMutationBody = AdminNationsRequest
    export type DrfadminNationsUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminNationsUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsUpdate>>, TError,{id: number;data: AdminNationsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNationsUpdate>>,
        TError,
        {id: number;data: AdminNationsRequest},
        TContext
      > => {
      return useMutation(getDrfadminNationsUpdateMutationOptions(options), queryClient);
    }
    /**
 * Admin ViewSet for managing Nation instances (countries/territories in the game).
 *
 * Provides CRUD operations for nations, allowing admins to:
 * - List all nations in their account
 * - Create new nations with initial resource allocations
 * - Update nation details (name, flag, constitution, borders)
 * - Delete nations (except World Bank special nation)
 *
 * Features:
 * - Filtering by class_name
 * - Ordering by name, class_name, created_at, or id
 * - Resource data included in responses
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of World Bank nation (special system nation)
 * - Scoped to current account only
 *
 * Performance:
 * - Prefetches resources and resource types to avoid N+1 queries
 * - Optimized for admin list views with resource data
 */
export const drfadminNationsPartialUpdate = (
    id: number,
    patchedAdminNationsRequest?: PatchedAdminNationsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminNations>(
      {url: `/drfadmin/nations/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminNationsRequest, signal
    },
      options);
    }




export const getDrfadminNationsPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsPartialUpdate>>, TError,{id: number;data?: PatchedAdminNationsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsPartialUpdate>>, TError,{id: number;data?: PatchedAdminNationsRequest}, TContext> => {

const mutationKey = ['drfadminNationsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNationsPartialUpdate>>, {id: number;data?: PatchedAdminNationsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminNationsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNationsPartialUpdate>>>
    export type DrfadminNationsPartialUpdateMutationBody = PatchedAdminNationsRequest | undefined
    export type DrfadminNationsPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminNationsPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsPartialUpdate>>, TError,{id: number;data?: PatchedAdminNationsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNationsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminNationsRequest},
        TContext
      > => {
      return useMutation(getDrfadminNationsPartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * Delete a Nation.
 *
 * Prevents deletion of the World Bank nation, which is a special
 * system nation used for administrative purposes.
 *
 * Returns:
 *     403 if attempting to delete World Bank nation
 *     200 with success message on successful deletion
 */
export const drfadminNationsDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/nations/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminNationsDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminNationsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNationsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminNationsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNationsDestroy>>>

    export type DrfadminNationsDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminNationsDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNationsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNationsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminNationsDestroyMutationOptions(options), queryClient);
    }
    export const drfadminNaturalDisastersList = (
    params?: DrfadminNaturalDisastersListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedNaturalDisasterCreateList>(
      {url: `/drfadmin/natural-disasters/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminNaturalDisastersListQueryKey = (params?: DrfadminNaturalDisastersListParams,) => {
    return [
    `/drfadmin/natural-disasters/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminNaturalDisastersListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError = ErrorType<ApiError>>(params?: DrfadminNaturalDisastersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminNaturalDisastersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminNaturalDisastersList>>> = ({ signal }) => drfadminNaturalDisastersList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminNaturalDisastersListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminNaturalDisastersList>>>
export type DrfadminNaturalDisastersListQueryError = ErrorType<ApiError>


export function useDrfadminNaturalDisastersList<TData = Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminNaturalDisastersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNaturalDisastersList>>,
          TError,
          Awaited<ReturnType<typeof drfadminNaturalDisastersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNaturalDisastersList<TData = Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminNaturalDisastersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNaturalDisastersList>>,
          TError,
          Awaited<ReturnType<typeof drfadminNaturalDisastersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNaturalDisastersList<TData = Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminNaturalDisastersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminNaturalDisastersList<TData = Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminNaturalDisastersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminNaturalDisastersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminNaturalDisastersCreate = (
    naturalDisasterCreateRequest: NaturalDisasterCreateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NaturalDisasterCreate>(
      {url: `/drfadmin/natural-disasters/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: naturalDisasterCreateRequest, signal
    },
      options);
    }




export const getDrfadminNaturalDisastersCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersCreate>>, TError,{data: NaturalDisasterCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersCreate>>, TError,{data: NaturalDisasterCreateRequest}, TContext> => {

const mutationKey = ['drfadminNaturalDisastersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNaturalDisastersCreate>>, {data: NaturalDisasterCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminNaturalDisastersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNaturalDisastersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNaturalDisastersCreate>>>
    export type DrfadminNaturalDisastersCreateMutationBody = NaturalDisasterCreateRequest
    export type DrfadminNaturalDisastersCreateMutationError = ErrorType<ApiError>

    export const useDrfadminNaturalDisastersCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersCreate>>, TError,{data: NaturalDisasterCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNaturalDisastersCreate>>,
        TError,
        {data: NaturalDisasterCreateRequest},
        TContext
      > => {
      return useMutation(getDrfadminNaturalDisastersCreateMutationOptions(options), queryClient);
    }
    export const drfadminNaturalDisastersRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NaturalDisasterCreate>(
      {url: `/drfadmin/natural-disasters/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminNaturalDisastersRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/natural-disasters/${id}/`
    ] as const;
    }


export const getDrfadminNaturalDisastersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminNaturalDisastersRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>> = ({ signal }) => drfadminNaturalDisastersRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminNaturalDisastersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>>
export type DrfadminNaturalDisastersRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminNaturalDisastersRetrieve<TData = Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNaturalDisastersRetrieve<TData = Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNaturalDisastersRetrieve<TData = Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminNaturalDisastersRetrieve<TData = Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminNaturalDisastersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminNaturalDisastersUpdate = (
    id: number,
    naturalDisasterCreateRequest: NaturalDisasterCreateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NaturalDisasterCreate>(
      {url: `/drfadmin/natural-disasters/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: naturalDisasterCreateRequest, signal
    },
      options);
    }




export const getDrfadminNaturalDisastersUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersUpdate>>, TError,{id: number;data: NaturalDisasterCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersUpdate>>, TError,{id: number;data: NaturalDisasterCreateRequest}, TContext> => {

const mutationKey = ['drfadminNaturalDisastersUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNaturalDisastersUpdate>>, {id: number;data: NaturalDisasterCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminNaturalDisastersUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNaturalDisastersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNaturalDisastersUpdate>>>
    export type DrfadminNaturalDisastersUpdateMutationBody = NaturalDisasterCreateRequest
    export type DrfadminNaturalDisastersUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminNaturalDisastersUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersUpdate>>, TError,{id: number;data: NaturalDisasterCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNaturalDisastersUpdate>>,
        TError,
        {id: number;data: NaturalDisasterCreateRequest},
        TContext
      > => {
      return useMutation(getDrfadminNaturalDisastersUpdateMutationOptions(options), queryClient);
    }
    export const drfadminNaturalDisastersPartialUpdate = (
    id: number,
    patchedNaturalDisasterCreateRequest?: PatchedNaturalDisasterCreateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NaturalDisasterCreate>(
      {url: `/drfadmin/natural-disasters/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedNaturalDisasterCreateRequest, signal
    },
      options);
    }




export const getDrfadminNaturalDisastersPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersPartialUpdate>>, TError,{id: number;data?: PatchedNaturalDisasterCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersPartialUpdate>>, TError,{id: number;data?: PatchedNaturalDisasterCreateRequest}, TContext> => {

const mutationKey = ['drfadminNaturalDisastersPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNaturalDisastersPartialUpdate>>, {id: number;data?: PatchedNaturalDisasterCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminNaturalDisastersPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNaturalDisastersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNaturalDisastersPartialUpdate>>>
    export type DrfadminNaturalDisastersPartialUpdateMutationBody = PatchedNaturalDisasterCreateRequest | undefined
    export type DrfadminNaturalDisastersPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminNaturalDisastersPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersPartialUpdate>>, TError,{id: number;data?: PatchedNaturalDisasterCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNaturalDisastersPartialUpdate>>,
        TError,
        {id: number;data?: PatchedNaturalDisasterCreateRequest},
        TContext
      > => {
      return useMutation(getDrfadminNaturalDisastersPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminNaturalDisastersDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/natural-disasters/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminNaturalDisastersDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminNaturalDisastersDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNaturalDisastersDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminNaturalDisastersDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNaturalDisastersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNaturalDisastersDestroy>>>

    export type DrfadminNaturalDisastersDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminNaturalDisastersDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNaturalDisastersDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNaturalDisastersDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminNaturalDisastersDestroyMutationOptions(options), queryClient);
    }
    export const drfadminNotesList = (
    params?: DrfadminNotesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedNoteList>(
      {url: `/drfadmin/notes/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminNotesListQueryKey = (params?: DrfadminNotesListParams,) => {
    return [
    `/drfadmin/notes/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminNotesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminNotesList>>, TError = ErrorType<ApiError>>(params?: DrfadminNotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminNotesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminNotesList>>> = ({ signal }) => drfadminNotesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminNotesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminNotesList>>>
export type DrfadminNotesListQueryError = ErrorType<ApiError>


export function useDrfadminNotesList<TData = Awaited<ReturnType<typeof drfadminNotesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminNotesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNotesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminNotesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNotesList<TData = Awaited<ReturnType<typeof drfadminNotesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminNotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNotesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminNotesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNotesList<TData = Awaited<ReturnType<typeof drfadminNotesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminNotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminNotesList<TData = Awaited<ReturnType<typeof drfadminNotesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminNotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminNotesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminNotesCreate = (
    noteRequest: NoteRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note>(
      {url: `/drfadmin/notes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: noteRequest, signal
    },
      options);
    }




export const getDrfadminNotesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesCreate>>, TError,{data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesCreate>>, TError,{data: NoteRequest}, TContext> => {

const mutationKey = ['drfadminNotesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNotesCreate>>, {data: NoteRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminNotesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNotesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNotesCreate>>>
    export type DrfadminNotesCreateMutationBody = NoteRequest
    export type DrfadminNotesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminNotesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesCreate>>, TError,{data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNotesCreate>>,
        TError,
        {data: NoteRequest},
        TContext
      > => {
      return useMutation(getDrfadminNotesCreateMutationOptions(options), queryClient);
    }
    export const drfadminNotesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note>(
      {url: `/drfadmin/notes/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminNotesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/notes/${id}/`
    ] as const;
    }


export const getDrfadminNotesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminNotesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminNotesRetrieve>>> = ({ signal }) => drfadminNotesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminNotesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminNotesRetrieve>>>
export type DrfadminNotesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminNotesRetrieve<TData = Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNotesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminNotesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNotesRetrieve<TData = Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminNotesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminNotesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminNotesRetrieve<TData = Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminNotesRetrieve<TData = Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminNotesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminNotesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminNotesUpdate = (
    id: number,
    noteRequest: NoteRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note>(
      {url: `/drfadmin/notes/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: noteRequest, signal
    },
      options);
    }




export const getDrfadminNotesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesUpdate>>, TError,{id: number;data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesUpdate>>, TError,{id: number;data: NoteRequest}, TContext> => {

const mutationKey = ['drfadminNotesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNotesUpdate>>, {id: number;data: NoteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminNotesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNotesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNotesUpdate>>>
    export type DrfadminNotesUpdateMutationBody = NoteRequest
    export type DrfadminNotesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminNotesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesUpdate>>, TError,{id: number;data: NoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNotesUpdate>>,
        TError,
        {id: number;data: NoteRequest},
        TContext
      > => {
      return useMutation(getDrfadminNotesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminNotesPartialUpdate = (
    id: number,
    patchedNoteRequest?: PatchedNoteRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Note>(
      {url: `/drfadmin/notes/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedNoteRequest, signal
    },
      options);
    }




export const getDrfadminNotesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesPartialUpdate>>, TError,{id: number;data?: PatchedNoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesPartialUpdate>>, TError,{id: number;data?: PatchedNoteRequest}, TContext> => {

const mutationKey = ['drfadminNotesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNotesPartialUpdate>>, {id: number;data?: PatchedNoteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminNotesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNotesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNotesPartialUpdate>>>
    export type DrfadminNotesPartialUpdateMutationBody = PatchedNoteRequest | undefined
    export type DrfadminNotesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminNotesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesPartialUpdate>>, TError,{id: number;data?: PatchedNoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNotesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedNoteRequest},
        TContext
      > => {
      return useMutation(getDrfadminNotesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminNotesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/notes/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminNotesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminNotesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminNotesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminNotesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminNotesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminNotesDestroy>>>

    export type DrfadminNotesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminNotesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminNotesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminNotesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminNotesDestroyMutationOptions(options), queryClient);
    }
    /**
 * Send a prompt to OpenAI and return the generated content
 */
export const drfadminOpenaiPromptCreate = (
    openAIPromptRequestRequest: OpenAIPromptRequestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OpenAIPromptResponse>(
      {url: `/drfadmin/openai-prompt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: openAIPromptRequestRequest, signal
    },
      options);
    }




export const getDrfadminOpenaiPromptCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminOpenaiPromptCreate>>, TError,{data: OpenAIPromptRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminOpenaiPromptCreate>>, TError,{data: OpenAIPromptRequestRequest}, TContext> => {

const mutationKey = ['drfadminOpenaiPromptCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminOpenaiPromptCreate>>, {data: OpenAIPromptRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminOpenaiPromptCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminOpenaiPromptCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminOpenaiPromptCreate>>>
    export type DrfadminOpenaiPromptCreateMutationBody = OpenAIPromptRequestRequest
    export type DrfadminOpenaiPromptCreateMutationError = ErrorType<ApiError>

    export const useDrfadminOpenaiPromptCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminOpenaiPromptCreate>>, TError,{data: OpenAIPromptRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminOpenaiPromptCreate>>,
        TError,
        {data: OpenAIPromptRequestRequest},
        TContext
      > => {
      return useMutation(getDrfadminOpenaiPromptCreateMutationOptions(options), queryClient);
    }
    export const drfadminPeaceTreatiesList = (
    params?: DrfadminPeaceTreatiesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedPeaceTreatyList>(
      {url: `/drfadmin/peace-treaties/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminPeaceTreatiesListQueryKey = (params?: DrfadminPeaceTreatiesListParams,) => {
    return [
    `/drfadmin/peace-treaties/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminPeaceTreatiesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError = ErrorType<ApiError>>(params?: DrfadminPeaceTreatiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminPeaceTreatiesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>> = ({ signal }) => drfadminPeaceTreatiesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminPeaceTreatiesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>>
export type DrfadminPeaceTreatiesListQueryError = ErrorType<ApiError>


export function useDrfadminPeaceTreatiesList<TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminPeaceTreatiesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPeaceTreatiesList<TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminPeaceTreatiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPeaceTreatiesList<TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminPeaceTreatiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminPeaceTreatiesList<TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminPeaceTreatiesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminPeaceTreatiesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminPeaceTreatiesCreate = (
    peaceTreatyRequest: PeaceTreatyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PeaceTreaty>(
      {url: `/drfadmin/peace-treaties/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: peaceTreatyRequest, signal
    },
      options);
    }




export const getDrfadminPeaceTreatiesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesCreate>>, TError,{data: PeaceTreatyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesCreate>>, TError,{data: PeaceTreatyRequest}, TContext> => {

const mutationKey = ['drfadminPeaceTreatiesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPeaceTreatiesCreate>>, {data: PeaceTreatyRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminPeaceTreatiesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPeaceTreatiesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPeaceTreatiesCreate>>>
    export type DrfadminPeaceTreatiesCreateMutationBody = PeaceTreatyRequest
    export type DrfadminPeaceTreatiesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminPeaceTreatiesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesCreate>>, TError,{data: PeaceTreatyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPeaceTreatiesCreate>>,
        TError,
        {data: PeaceTreatyRequest},
        TContext
      > => {
      return useMutation(getDrfadminPeaceTreatiesCreateMutationOptions(options), queryClient);
    }
    export const drfadminPeaceTreatiesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PeaceTreaty>(
      {url: `/drfadmin/peace-treaties/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminPeaceTreatiesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/peace-treaties/${id}/`
    ] as const;
    }


export const getDrfadminPeaceTreatiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminPeaceTreatiesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>> = ({ signal }) => drfadminPeaceTreatiesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminPeaceTreatiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>>
export type DrfadminPeaceTreatiesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminPeaceTreatiesRetrieve<TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPeaceTreatiesRetrieve<TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPeaceTreatiesRetrieve<TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminPeaceTreatiesRetrieve<TData = Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminPeaceTreatiesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminPeaceTreatiesUpdate = (
    id: number,
    peaceTreatyRequest: PeaceTreatyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PeaceTreaty>(
      {url: `/drfadmin/peace-treaties/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: peaceTreatyRequest, signal
    },
      options);
    }




export const getDrfadminPeaceTreatiesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesUpdate>>, TError,{id: number;data: PeaceTreatyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesUpdate>>, TError,{id: number;data: PeaceTreatyRequest}, TContext> => {

const mutationKey = ['drfadminPeaceTreatiesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPeaceTreatiesUpdate>>, {id: number;data: PeaceTreatyRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminPeaceTreatiesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPeaceTreatiesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPeaceTreatiesUpdate>>>
    export type DrfadminPeaceTreatiesUpdateMutationBody = PeaceTreatyRequest
    export type DrfadminPeaceTreatiesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminPeaceTreatiesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesUpdate>>, TError,{id: number;data: PeaceTreatyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPeaceTreatiesUpdate>>,
        TError,
        {id: number;data: PeaceTreatyRequest},
        TContext
      > => {
      return useMutation(getDrfadminPeaceTreatiesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminPeaceTreatiesPartialUpdate = (
    id: number,
    patchedPeaceTreatyRequest?: PatchedPeaceTreatyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PeaceTreaty>(
      {url: `/drfadmin/peace-treaties/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPeaceTreatyRequest, signal
    },
      options);
    }




export const getDrfadminPeaceTreatiesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesPartialUpdate>>, TError,{id: number;data?: PatchedPeaceTreatyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesPartialUpdate>>, TError,{id: number;data?: PatchedPeaceTreatyRequest}, TContext> => {

const mutationKey = ['drfadminPeaceTreatiesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPeaceTreatiesPartialUpdate>>, {id: number;data?: PatchedPeaceTreatyRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminPeaceTreatiesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPeaceTreatiesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPeaceTreatiesPartialUpdate>>>
    export type DrfadminPeaceTreatiesPartialUpdateMutationBody = PatchedPeaceTreatyRequest | undefined
    export type DrfadminPeaceTreatiesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminPeaceTreatiesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesPartialUpdate>>, TError,{id: number;data?: PatchedPeaceTreatyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPeaceTreatiesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedPeaceTreatyRequest},
        TContext
      > => {
      return useMutation(getDrfadminPeaceTreatiesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminPeaceTreatiesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/peace-treaties/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminPeaceTreatiesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminPeaceTreatiesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPeaceTreatiesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminPeaceTreatiesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPeaceTreatiesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPeaceTreatiesDestroy>>>

    export type DrfadminPeaceTreatiesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminPeaceTreatiesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPeaceTreatiesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPeaceTreatiesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminPeaceTreatiesDestroyMutationOptions(options), queryClient);
    }
    export const drfadminPopulationChangeEventList = (
    params?: DrfadminPopulationChangeEventListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedPopulationChangeEventList>(
      {url: `/drfadmin/population-change-event/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminPopulationChangeEventListQueryKey = (params?: DrfadminPopulationChangeEventListParams,) => {
    return [
    `/drfadmin/population-change-event/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminPopulationChangeEventListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError = ErrorType<ApiError>>(params?: DrfadminPopulationChangeEventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminPopulationChangeEventListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>> = ({ signal }) => drfadminPopulationChangeEventList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminPopulationChangeEventListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>>
export type DrfadminPopulationChangeEventListQueryError = ErrorType<ApiError>


export function useDrfadminPopulationChangeEventList<TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminPopulationChangeEventListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>,
          TError,
          Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPopulationChangeEventList<TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminPopulationChangeEventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>,
          TError,
          Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPopulationChangeEventList<TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminPopulationChangeEventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminPopulationChangeEventList<TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminPopulationChangeEventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminPopulationChangeEventListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminPopulationChangeEventCreate = (
    populationChangeEventRequest: PopulationChangeEventRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PopulationChangeEvent>(
      {url: `/drfadmin/population-change-event/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: populationChangeEventRequest, signal
    },
      options);
    }




export const getDrfadminPopulationChangeEventCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventCreate>>, TError,{data: PopulationChangeEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventCreate>>, TError,{data: PopulationChangeEventRequest}, TContext> => {

const mutationKey = ['drfadminPopulationChangeEventCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPopulationChangeEventCreate>>, {data: PopulationChangeEventRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminPopulationChangeEventCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPopulationChangeEventCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPopulationChangeEventCreate>>>
    export type DrfadminPopulationChangeEventCreateMutationBody = PopulationChangeEventRequest
    export type DrfadminPopulationChangeEventCreateMutationError = ErrorType<ApiError>

    export const useDrfadminPopulationChangeEventCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventCreate>>, TError,{data: PopulationChangeEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPopulationChangeEventCreate>>,
        TError,
        {data: PopulationChangeEventRequest},
        TContext
      > => {
      return useMutation(getDrfadminPopulationChangeEventCreateMutationOptions(options), queryClient);
    }
    export const drfadminPopulationChangeEventRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PopulationChangeEvent>(
      {url: `/drfadmin/population-change-event/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminPopulationChangeEventRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/population-change-event/${id}/`
    ] as const;
    }


export const getDrfadminPopulationChangeEventRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminPopulationChangeEventRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>> = ({ signal }) => drfadminPopulationChangeEventRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminPopulationChangeEventRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>>
export type DrfadminPopulationChangeEventRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminPopulationChangeEventRetrieve<TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPopulationChangeEventRetrieve<TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPopulationChangeEventRetrieve<TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminPopulationChangeEventRetrieve<TData = Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminPopulationChangeEventRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminPopulationChangeEventUpdate = (
    id: number,
    populationChangeEventRequest: PopulationChangeEventRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PopulationChangeEvent>(
      {url: `/drfadmin/population-change-event/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: populationChangeEventRequest, signal
    },
      options);
    }




export const getDrfadminPopulationChangeEventUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventUpdate>>, TError,{id: number;data: PopulationChangeEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventUpdate>>, TError,{id: number;data: PopulationChangeEventRequest}, TContext> => {

const mutationKey = ['drfadminPopulationChangeEventUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPopulationChangeEventUpdate>>, {id: number;data: PopulationChangeEventRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminPopulationChangeEventUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPopulationChangeEventUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPopulationChangeEventUpdate>>>
    export type DrfadminPopulationChangeEventUpdateMutationBody = PopulationChangeEventRequest
    export type DrfadminPopulationChangeEventUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminPopulationChangeEventUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventUpdate>>, TError,{id: number;data: PopulationChangeEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPopulationChangeEventUpdate>>,
        TError,
        {id: number;data: PopulationChangeEventRequest},
        TContext
      > => {
      return useMutation(getDrfadminPopulationChangeEventUpdateMutationOptions(options), queryClient);
    }
    export const drfadminPopulationChangeEventPartialUpdate = (
    id: number,
    patchedPopulationChangeEventRequest?: PatchedPopulationChangeEventRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PopulationChangeEvent>(
      {url: `/drfadmin/population-change-event/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPopulationChangeEventRequest, signal
    },
      options);
    }




export const getDrfadminPopulationChangeEventPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventPartialUpdate>>, TError,{id: number;data?: PatchedPopulationChangeEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventPartialUpdate>>, TError,{id: number;data?: PatchedPopulationChangeEventRequest}, TContext> => {

const mutationKey = ['drfadminPopulationChangeEventPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPopulationChangeEventPartialUpdate>>, {id: number;data?: PatchedPopulationChangeEventRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminPopulationChangeEventPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPopulationChangeEventPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPopulationChangeEventPartialUpdate>>>
    export type DrfadminPopulationChangeEventPartialUpdateMutationBody = PatchedPopulationChangeEventRequest | undefined
    export type DrfadminPopulationChangeEventPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminPopulationChangeEventPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventPartialUpdate>>, TError,{id: number;data?: PatchedPopulationChangeEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPopulationChangeEventPartialUpdate>>,
        TError,
        {id: number;data?: PatchedPopulationChangeEventRequest},
        TContext
      > => {
      return useMutation(getDrfadminPopulationChangeEventPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminPopulationChangeEventDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/population-change-event/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminPopulationChangeEventDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminPopulationChangeEventDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPopulationChangeEventDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminPopulationChangeEventDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPopulationChangeEventDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPopulationChangeEventDestroy>>>

    export type DrfadminPopulationChangeEventDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminPopulationChangeEventDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPopulationChangeEventDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPopulationChangeEventDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminPopulationChangeEventDestroyMutationOptions(options), queryClient);
    }
    export const drfadminPurchasesList = (
    params?: DrfadminPurchasesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedPurchaseList>(
      {url: `/drfadmin/purchases/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminPurchasesListQueryKey = (params?: DrfadminPurchasesListParams,) => {
    return [
    `/drfadmin/purchases/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminPurchasesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminPurchasesList>>, TError = ErrorType<ApiError>>(params?: DrfadminPurchasesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminPurchasesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminPurchasesList>>> = ({ signal }) => drfadminPurchasesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminPurchasesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminPurchasesList>>>
export type DrfadminPurchasesListQueryError = ErrorType<ApiError>


export function useDrfadminPurchasesList<TData = Awaited<ReturnType<typeof drfadminPurchasesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminPurchasesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPurchasesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminPurchasesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPurchasesList<TData = Awaited<ReturnType<typeof drfadminPurchasesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminPurchasesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPurchasesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminPurchasesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPurchasesList<TData = Awaited<ReturnType<typeof drfadminPurchasesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminPurchasesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminPurchasesList<TData = Awaited<ReturnType<typeof drfadminPurchasesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminPurchasesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminPurchasesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminPurchasesCreate = (
    purchaseRequest: PurchaseRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Purchase>(
      {url: `/drfadmin/purchases/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: purchaseRequest, signal
    },
      options);
    }




export const getDrfadminPurchasesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesCreate>>, TError,{data: PurchaseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesCreate>>, TError,{data: PurchaseRequest}, TContext> => {

const mutationKey = ['drfadminPurchasesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPurchasesCreate>>, {data: PurchaseRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminPurchasesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPurchasesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPurchasesCreate>>>
    export type DrfadminPurchasesCreateMutationBody = PurchaseRequest
    export type DrfadminPurchasesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminPurchasesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesCreate>>, TError,{data: PurchaseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPurchasesCreate>>,
        TError,
        {data: PurchaseRequest},
        TContext
      > => {
      return useMutation(getDrfadminPurchasesCreateMutationOptions(options), queryClient);
    }
    export const drfadminPurchasesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Purchase>(
      {url: `/drfadmin/purchases/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminPurchasesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/purchases/${id}/`
    ] as const;
    }


export const getDrfadminPurchasesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminPurchasesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>> = ({ signal }) => drfadminPurchasesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminPurchasesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>>
export type DrfadminPurchasesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminPurchasesRetrieve<TData = Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPurchasesRetrieve<TData = Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminPurchasesRetrieve<TData = Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminPurchasesRetrieve<TData = Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminPurchasesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminPurchasesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminPurchasesUpdate = (
    id: number,
    purchaseRequest: PurchaseRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Purchase>(
      {url: `/drfadmin/purchases/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: purchaseRequest, signal
    },
      options);
    }




export const getDrfadminPurchasesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesUpdate>>, TError,{id: number;data: PurchaseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesUpdate>>, TError,{id: number;data: PurchaseRequest}, TContext> => {

const mutationKey = ['drfadminPurchasesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPurchasesUpdate>>, {id: number;data: PurchaseRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminPurchasesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPurchasesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPurchasesUpdate>>>
    export type DrfadminPurchasesUpdateMutationBody = PurchaseRequest
    export type DrfadminPurchasesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminPurchasesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesUpdate>>, TError,{id: number;data: PurchaseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPurchasesUpdate>>,
        TError,
        {id: number;data: PurchaseRequest},
        TContext
      > => {
      return useMutation(getDrfadminPurchasesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminPurchasesPartialUpdate = (
    id: number,
    patchedPurchaseRequest?: PatchedPurchaseRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Purchase>(
      {url: `/drfadmin/purchases/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPurchaseRequest, signal
    },
      options);
    }




export const getDrfadminPurchasesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesPartialUpdate>>, TError,{id: number;data?: PatchedPurchaseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesPartialUpdate>>, TError,{id: number;data?: PatchedPurchaseRequest}, TContext> => {

const mutationKey = ['drfadminPurchasesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPurchasesPartialUpdate>>, {id: number;data?: PatchedPurchaseRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminPurchasesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPurchasesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPurchasesPartialUpdate>>>
    export type DrfadminPurchasesPartialUpdateMutationBody = PatchedPurchaseRequest | undefined
    export type DrfadminPurchasesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminPurchasesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesPartialUpdate>>, TError,{id: number;data?: PatchedPurchaseRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPurchasesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedPurchaseRequest},
        TContext
      > => {
      return useMutation(getDrfadminPurchasesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminPurchasesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/purchases/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminPurchasesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminPurchasesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPurchasesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminPurchasesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPurchasesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPurchasesDestroy>>>

    export type DrfadminPurchasesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminPurchasesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPurchasesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminPurchasesDestroyMutationOptions(options), queryClient);
    }
    export const drfadminPurchasesGiftCreate = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Purchase>(
      {url: `/drfadmin/purchases/${id}/gift/`, method: 'POST', signal
    },
      options);
    }




export const getDrfadminPurchasesGiftCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesGiftCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesGiftCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminPurchasesGiftCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminPurchasesGiftCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminPurchasesGiftCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminPurchasesGiftCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminPurchasesGiftCreate>>>

    export type DrfadminPurchasesGiftCreateMutationError = ErrorType<ApiError>

    export const useDrfadminPurchasesGiftCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminPurchasesGiftCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminPurchasesGiftCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminPurchasesGiftCreateMutationOptions(options), queryClient);
    }
    /**
 * Resets military status for all purchases in the specified class, clearing attacked_at and moved_at timestamps.
 * @summary Reset Military
 */
export const drfadminResetMilitaryCreate = (
    resetMilitaryRequest: ResetMilitaryRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ResetMilitaryResponse>(
      {url: `/drfadmin/reset-military`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetMilitaryRequest, signal
    },
      options);
    }




export const getDrfadminResetMilitaryCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResetMilitaryCreate>>, TError,{data: ResetMilitaryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminResetMilitaryCreate>>, TError,{data: ResetMilitaryRequest}, TContext> => {

const mutationKey = ['drfadminResetMilitaryCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminResetMilitaryCreate>>, {data: ResetMilitaryRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminResetMilitaryCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminResetMilitaryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminResetMilitaryCreate>>>
    export type DrfadminResetMilitaryCreateMutationBody = ResetMilitaryRequest
    export type DrfadminResetMilitaryCreateMutationError = ErrorType<ApiError>

    /**
 * @summary Reset Military
 */
export const useDrfadminResetMilitaryCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResetMilitaryCreate>>, TError,{data: ResetMilitaryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminResetMilitaryCreate>>,
        TError,
        {data: ResetMilitaryRequest},
        TContext
      > => {
      return useMutation(getDrfadminResetMilitaryCreateMutationOptions(options), queryClient);
    }
    export const drfadminResourceTypesList = (
    params?: DrfadminResourceTypesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedResourceTypeList>(
      {url: `/drfadmin/resource-types/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminResourceTypesListQueryKey = (params?: DrfadminResourceTypesListParams,) => {
    return [
    `/drfadmin/resource-types/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminResourceTypesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError = ErrorType<ApiError>>(params?: DrfadminResourceTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminResourceTypesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminResourceTypesList>>> = ({ signal }) => drfadminResourceTypesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminResourceTypesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminResourceTypesList>>>
export type DrfadminResourceTypesListQueryError = ErrorType<ApiError>


export function useDrfadminResourceTypesList<TData = Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminResourceTypesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminResourceTypesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminResourceTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminResourceTypesList<TData = Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminResourceTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminResourceTypesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminResourceTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminResourceTypesList<TData = Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminResourceTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminResourceTypesList<TData = Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminResourceTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminResourceTypesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminResourceTypesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ResourceType>(
      {url: `/drfadmin/resource-types/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminResourceTypesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/resource-types/${id}/`
    ] as const;
    }


export const getDrfadminResourceTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminResourceTypesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>> = ({ signal }) => drfadminResourceTypesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminResourceTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>>
export type DrfadminResourceTypesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminResourceTypesRetrieve<TData = Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminResourceTypesRetrieve<TData = Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminResourceTypesRetrieve<TData = Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminResourceTypesRetrieve<TData = Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminResourceTypesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminResourcesList = (
    params?: DrfadminResourcesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedResourceList>(
      {url: `/drfadmin/resources/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminResourcesListQueryKey = (params?: DrfadminResourcesListParams,) => {
    return [
    `/drfadmin/resources/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminResourcesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminResourcesList>>, TError = ErrorType<ApiError>>(params?: DrfadminResourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminResourcesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminResourcesList>>> = ({ signal }) => drfadminResourcesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminResourcesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminResourcesList>>>
export type DrfadminResourcesListQueryError = ErrorType<ApiError>


export function useDrfadminResourcesList<TData = Awaited<ReturnType<typeof drfadminResourcesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminResourcesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminResourcesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminResourcesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminResourcesList<TData = Awaited<ReturnType<typeof drfadminResourcesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminResourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminResourcesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminResourcesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminResourcesList<TData = Awaited<ReturnType<typeof drfadminResourcesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminResourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminResourcesList<TData = Awaited<ReturnType<typeof drfadminResourcesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminResourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminResourcesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminResourcesCreate = (
    resourceRequest: ResourceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Resource>(
      {url: `/drfadmin/resources/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resourceRequest, signal
    },
      options);
    }




export const getDrfadminResourcesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesCreate>>, TError,{data: ResourceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesCreate>>, TError,{data: ResourceRequest}, TContext> => {

const mutationKey = ['drfadminResourcesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminResourcesCreate>>, {data: ResourceRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminResourcesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminResourcesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminResourcesCreate>>>
    export type DrfadminResourcesCreateMutationBody = ResourceRequest
    export type DrfadminResourcesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminResourcesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesCreate>>, TError,{data: ResourceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminResourcesCreate>>,
        TError,
        {data: ResourceRequest},
        TContext
      > => {
      return useMutation(getDrfadminResourcesCreateMutationOptions(options), queryClient);
    }
    export const drfadminResourcesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Resource>(
      {url: `/drfadmin/resources/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminResourcesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/resources/${id}/`
    ] as const;
    }


export const getDrfadminResourcesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminResourcesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminResourcesRetrieve>>> = ({ signal }) => drfadminResourcesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminResourcesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminResourcesRetrieve>>>
export type DrfadminResourcesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminResourcesRetrieve<TData = Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminResourcesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminResourcesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminResourcesRetrieve<TData = Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminResourcesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminResourcesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminResourcesRetrieve<TData = Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminResourcesRetrieve<TData = Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminResourcesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminResourcesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminResourcesUpdate = (
    id: number,
    resourceRequest: ResourceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Resource>(
      {url: `/drfadmin/resources/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: resourceRequest, signal
    },
      options);
    }




export const getDrfadminResourcesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesUpdate>>, TError,{id: number;data: ResourceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesUpdate>>, TError,{id: number;data: ResourceRequest}, TContext> => {

const mutationKey = ['drfadminResourcesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminResourcesUpdate>>, {id: number;data: ResourceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminResourcesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminResourcesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminResourcesUpdate>>>
    export type DrfadminResourcesUpdateMutationBody = ResourceRequest
    export type DrfadminResourcesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminResourcesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesUpdate>>, TError,{id: number;data: ResourceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminResourcesUpdate>>,
        TError,
        {id: number;data: ResourceRequest},
        TContext
      > => {
      return useMutation(getDrfadminResourcesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminResourcesPartialUpdate = (
    id: number,
    patchedResourceRequest?: PatchedResourceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Resource>(
      {url: `/drfadmin/resources/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedResourceRequest, signal
    },
      options);
    }




export const getDrfadminResourcesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesPartialUpdate>>, TError,{id: number;data?: PatchedResourceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesPartialUpdate>>, TError,{id: number;data?: PatchedResourceRequest}, TContext> => {

const mutationKey = ['drfadminResourcesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminResourcesPartialUpdate>>, {id: number;data?: PatchedResourceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminResourcesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminResourcesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminResourcesPartialUpdate>>>
    export type DrfadminResourcesPartialUpdateMutationBody = PatchedResourceRequest | undefined
    export type DrfadminResourcesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminResourcesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesPartialUpdate>>, TError,{id: number;data?: PatchedResourceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminResourcesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedResourceRequest},
        TContext
      > => {
      return useMutation(getDrfadminResourcesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminResourcesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/resources/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminResourcesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminResourcesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminResourcesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminResourcesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminResourcesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminResourcesDestroy>>>

    export type DrfadminResourcesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminResourcesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminResourcesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminResourcesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminResourcesDestroyMutationOptions(options), queryClient);
    }
    export const drfadminRolePermissionsList = (
    params?: DrfadminRolePermissionsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedRolePermissionsList>(
      {url: `/drfadmin/role-permissions/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminRolePermissionsListQueryKey = (params?: DrfadminRolePermissionsListParams,) => {
    return [
    `/drfadmin/role-permissions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminRolePermissionsListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError = ErrorType<ApiError>>(params?: DrfadminRolePermissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminRolePermissionsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminRolePermissionsList>>> = ({ signal }) => drfadminRolePermissionsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminRolePermissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminRolePermissionsList>>>
export type DrfadminRolePermissionsListQueryError = ErrorType<ApiError>


export function useDrfadminRolePermissionsList<TData = Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminRolePermissionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminRolePermissionsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminRolePermissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminRolePermissionsList<TData = Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminRolePermissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminRolePermissionsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminRolePermissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminRolePermissionsList<TData = Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminRolePermissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminRolePermissionsList<TData = Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminRolePermissionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminRolePermissionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminRolePermissionsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RolePermissions>(
      {url: `/drfadmin/role-permissions/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminRolePermissionsRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/role-permissions/${id}/`
    ] as const;
    }


export const getDrfadminRolePermissionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminRolePermissionsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>> = ({ signal }) => drfadminRolePermissionsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminRolePermissionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>>
export type DrfadminRolePermissionsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminRolePermissionsRetrieve<TData = Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminRolePermissionsRetrieve<TData = Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminRolePermissionsRetrieve<TData = Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminRolePermissionsRetrieve<TData = Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolePermissionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminRolePermissionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminRolesList = (
    params?: DrfadminRolesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminRoleList>(
      {url: `/drfadmin/roles/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminRolesListQueryKey = (params?: DrfadminRolesListParams,) => {
    return [
    `/drfadmin/roles/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminRolesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminRolesList>>, TError = ErrorType<ApiError>>(params?: DrfadminRolesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminRolesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminRolesList>>> = ({ signal }) => drfadminRolesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminRolesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminRolesList>>>
export type DrfadminRolesListQueryError = ErrorType<ApiError>


export function useDrfadminRolesList<TData = Awaited<ReturnType<typeof drfadminRolesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminRolesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminRolesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminRolesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminRolesList<TData = Awaited<ReturnType<typeof drfadminRolesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminRolesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminRolesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminRolesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminRolesList<TData = Awaited<ReturnType<typeof drfadminRolesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminRolesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminRolesList<TData = Awaited<ReturnType<typeof drfadminRolesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminRolesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminRolesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminRolesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminRole>(
      {url: `/drfadmin/roles/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminRolesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/roles/${id}/`
    ] as const;
    }


export const getDrfadminRolesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminRolesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminRolesRetrieve>>> = ({ signal }) => drfadminRolesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminRolesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminRolesRetrieve>>>
export type DrfadminRolesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminRolesRetrieve<TData = Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminRolesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminRolesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminRolesRetrieve<TData = Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminRolesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminRolesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminRolesRetrieve<TData = Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminRolesRetrieve<TData = Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminRolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminRolesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminSubpoenasList = (
    params?: DrfadminSubpoenasListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedSubpoenaList>(
      {url: `/drfadmin/subpoenas/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminSubpoenasListQueryKey = (params?: DrfadminSubpoenasListParams,) => {
    return [
    `/drfadmin/subpoenas/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminSubpoenasListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError = ErrorType<ApiError>>(params?: DrfadminSubpoenasListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminSubpoenasListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminSubpoenasList>>> = ({ signal }) => drfadminSubpoenasList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminSubpoenasListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminSubpoenasList>>>
export type DrfadminSubpoenasListQueryError = ErrorType<ApiError>


export function useDrfadminSubpoenasList<TData = Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminSubpoenasListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminSubpoenasList>>,
          TError,
          Awaited<ReturnType<typeof drfadminSubpoenasList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminSubpoenasList<TData = Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminSubpoenasListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminSubpoenasList>>,
          TError,
          Awaited<ReturnType<typeof drfadminSubpoenasList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminSubpoenasList<TData = Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminSubpoenasListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminSubpoenasList<TData = Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminSubpoenasListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminSubpoenasListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminSubpoenasCreate = (
    subpoenaRequest: SubpoenaRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Subpoena>(
      {url: `/drfadmin/subpoenas/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subpoenaRequest, signal
    },
      options);
    }




export const getDrfadminSubpoenasCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasCreate>>, TError,{data: SubpoenaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasCreate>>, TError,{data: SubpoenaRequest}, TContext> => {

const mutationKey = ['drfadminSubpoenasCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminSubpoenasCreate>>, {data: SubpoenaRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminSubpoenasCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminSubpoenasCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminSubpoenasCreate>>>
    export type DrfadminSubpoenasCreateMutationBody = SubpoenaRequest
    export type DrfadminSubpoenasCreateMutationError = ErrorType<ApiError>

    export const useDrfadminSubpoenasCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasCreate>>, TError,{data: SubpoenaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminSubpoenasCreate>>,
        TError,
        {data: SubpoenaRequest},
        TContext
      > => {
      return useMutation(getDrfadminSubpoenasCreateMutationOptions(options), queryClient);
    }
    export const drfadminSubpoenasRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Subpoena>(
      {url: `/drfadmin/subpoenas/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminSubpoenasRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/subpoenas/${id}/`
    ] as const;
    }


export const getDrfadminSubpoenasRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminSubpoenasRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>> = ({ signal }) => drfadminSubpoenasRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminSubpoenasRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>>
export type DrfadminSubpoenasRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminSubpoenasRetrieve<TData = Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminSubpoenasRetrieve<TData = Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminSubpoenasRetrieve<TData = Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminSubpoenasRetrieve<TData = Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminSubpoenasRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminSubpoenasRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminSubpoenasUpdate = (
    id: number,
    subpoenaRequest: SubpoenaRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Subpoena>(
      {url: `/drfadmin/subpoenas/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: subpoenaRequest, signal
    },
      options);
    }




export const getDrfadminSubpoenasUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasUpdate>>, TError,{id: number;data: SubpoenaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasUpdate>>, TError,{id: number;data: SubpoenaRequest}, TContext> => {

const mutationKey = ['drfadminSubpoenasUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminSubpoenasUpdate>>, {id: number;data: SubpoenaRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminSubpoenasUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminSubpoenasUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminSubpoenasUpdate>>>
    export type DrfadminSubpoenasUpdateMutationBody = SubpoenaRequest
    export type DrfadminSubpoenasUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminSubpoenasUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasUpdate>>, TError,{id: number;data: SubpoenaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminSubpoenasUpdate>>,
        TError,
        {id: number;data: SubpoenaRequest},
        TContext
      > => {
      return useMutation(getDrfadminSubpoenasUpdateMutationOptions(options), queryClient);
    }
    export const drfadminSubpoenasPartialUpdate = (
    id: number,
    patchedSubpoenaRequest?: PatchedSubpoenaRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Subpoena>(
      {url: `/drfadmin/subpoenas/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedSubpoenaRequest, signal
    },
      options);
    }




export const getDrfadminSubpoenasPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasPartialUpdate>>, TError,{id: number;data?: PatchedSubpoenaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasPartialUpdate>>, TError,{id: number;data?: PatchedSubpoenaRequest}, TContext> => {

const mutationKey = ['drfadminSubpoenasPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminSubpoenasPartialUpdate>>, {id: number;data?: PatchedSubpoenaRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminSubpoenasPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminSubpoenasPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminSubpoenasPartialUpdate>>>
    export type DrfadminSubpoenasPartialUpdateMutationBody = PatchedSubpoenaRequest | undefined
    export type DrfadminSubpoenasPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminSubpoenasPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasPartialUpdate>>, TError,{id: number;data?: PatchedSubpoenaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminSubpoenasPartialUpdate>>,
        TError,
        {id: number;data?: PatchedSubpoenaRequest},
        TContext
      > => {
      return useMutation(getDrfadminSubpoenasPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminSubpoenasDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/subpoenas/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminSubpoenasDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminSubpoenasDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminSubpoenasDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminSubpoenasDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminSubpoenasDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminSubpoenasDestroy>>>

    export type DrfadminSubpoenasDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminSubpoenasDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminSubpoenasDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminSubpoenasDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminSubpoenasDestroyMutationOptions(options), queryClient);
    }
    export const drfadminTradeAlliancesList = (
    params?: DrfadminTradeAlliancesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedNewTradeAllianceList>(
      {url: `/drfadmin/trade-alliances/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminTradeAlliancesListQueryKey = (params?: DrfadminTradeAlliancesListParams,) => {
    return [
    `/drfadmin/trade-alliances/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminTradeAlliancesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError = ErrorType<ApiError>>(params?: DrfadminTradeAlliancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminTradeAlliancesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminTradeAlliancesList>>> = ({ signal }) => drfadminTradeAlliancesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminTradeAlliancesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminTradeAlliancesList>>>
export type DrfadminTradeAlliancesListQueryError = ErrorType<ApiError>


export function useDrfadminTradeAlliancesList<TData = Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminTradeAlliancesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminTradeAlliancesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminTradeAlliancesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminTradeAlliancesList<TData = Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminTradeAlliancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminTradeAlliancesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminTradeAlliancesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminTradeAlliancesList<TData = Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminTradeAlliancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminTradeAlliancesList<TData = Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminTradeAlliancesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminTradeAlliancesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminTradeAlliancesCreate = (
    newTradeAllianceRequest: NewTradeAllianceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewTradeAlliance>(
      {url: `/drfadmin/trade-alliances/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newTradeAllianceRequest, signal
    },
      options);
    }




export const getDrfadminTradeAlliancesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesCreate>>, TError,{data: NewTradeAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesCreate>>, TError,{data: NewTradeAllianceRequest}, TContext> => {

const mutationKey = ['drfadminTradeAlliancesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminTradeAlliancesCreate>>, {data: NewTradeAllianceRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminTradeAlliancesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminTradeAlliancesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminTradeAlliancesCreate>>>
    export type DrfadminTradeAlliancesCreateMutationBody = NewTradeAllianceRequest
    export type DrfadminTradeAlliancesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminTradeAlliancesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesCreate>>, TError,{data: NewTradeAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminTradeAlliancesCreate>>,
        TError,
        {data: NewTradeAllianceRequest},
        TContext
      > => {
      return useMutation(getDrfadminTradeAlliancesCreateMutationOptions(options), queryClient);
    }
    export const drfadminTradeAlliancesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewTradeAlliance>(
      {url: `/drfadmin/trade-alliances/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminTradeAlliancesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/trade-alliances/${id}/`
    ] as const;
    }


export const getDrfadminTradeAlliancesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminTradeAlliancesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>> = ({ signal }) => drfadminTradeAlliancesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminTradeAlliancesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>>
export type DrfadminTradeAlliancesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminTradeAlliancesRetrieve<TData = Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminTradeAlliancesRetrieve<TData = Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminTradeAlliancesRetrieve<TData = Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminTradeAlliancesRetrieve<TData = Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminTradeAlliancesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminTradeAlliancesUpdate = (
    id: number,
    newTradeAllianceRequest: NewTradeAllianceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewTradeAlliance>(
      {url: `/drfadmin/trade-alliances/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: newTradeAllianceRequest, signal
    },
      options);
    }




export const getDrfadminTradeAlliancesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesUpdate>>, TError,{id: number;data: NewTradeAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesUpdate>>, TError,{id: number;data: NewTradeAllianceRequest}, TContext> => {

const mutationKey = ['drfadminTradeAlliancesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminTradeAlliancesUpdate>>, {id: number;data: NewTradeAllianceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminTradeAlliancesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminTradeAlliancesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminTradeAlliancesUpdate>>>
    export type DrfadminTradeAlliancesUpdateMutationBody = NewTradeAllianceRequest
    export type DrfadminTradeAlliancesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminTradeAlliancesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesUpdate>>, TError,{id: number;data: NewTradeAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminTradeAlliancesUpdate>>,
        TError,
        {id: number;data: NewTradeAllianceRequest},
        TContext
      > => {
      return useMutation(getDrfadminTradeAlliancesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminTradeAlliancesPartialUpdate = (
    id: number,
    patchedNewTradeAllianceRequest?: PatchedNewTradeAllianceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewTradeAlliance>(
      {url: `/drfadmin/trade-alliances/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedNewTradeAllianceRequest, signal
    },
      options);
    }




export const getDrfadminTradeAlliancesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesPartialUpdate>>, TError,{id: number;data?: PatchedNewTradeAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesPartialUpdate>>, TError,{id: number;data?: PatchedNewTradeAllianceRequest}, TContext> => {

const mutationKey = ['drfadminTradeAlliancesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminTradeAlliancesPartialUpdate>>, {id: number;data?: PatchedNewTradeAllianceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminTradeAlliancesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminTradeAlliancesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminTradeAlliancesPartialUpdate>>>
    export type DrfadminTradeAlliancesPartialUpdateMutationBody = PatchedNewTradeAllianceRequest | undefined
    export type DrfadminTradeAlliancesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminTradeAlliancesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesPartialUpdate>>, TError,{id: number;data?: PatchedNewTradeAllianceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminTradeAlliancesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedNewTradeAllianceRequest},
        TContext
      > => {
      return useMutation(getDrfadminTradeAlliancesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminTradeAlliancesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/trade-alliances/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminTradeAlliancesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminTradeAlliancesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminTradeAlliancesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminTradeAlliancesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminTradeAlliancesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminTradeAlliancesDestroy>>>

    export type DrfadminTradeAlliancesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminTradeAlliancesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradeAlliancesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminTradeAlliancesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminTradeAlliancesDestroyMutationOptions(options), queryClient);
    }
    export const drfadminTradesList = (
    params?: DrfadminTradesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedNewTradeList>(
      {url: `/drfadmin/trades/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminTradesListQueryKey = (params?: DrfadminTradesListParams,) => {
    return [
    `/drfadmin/trades/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminTradesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminTradesList>>, TError = ErrorType<ApiError>>(params?: DrfadminTradesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminTradesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminTradesList>>> = ({ signal }) => drfadminTradesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminTradesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminTradesList>>>
export type DrfadminTradesListQueryError = ErrorType<ApiError>


export function useDrfadminTradesList<TData = Awaited<ReturnType<typeof drfadminTradesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminTradesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminTradesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminTradesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminTradesList<TData = Awaited<ReturnType<typeof drfadminTradesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminTradesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminTradesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminTradesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminTradesList<TData = Awaited<ReturnType<typeof drfadminTradesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminTradesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminTradesList<TData = Awaited<ReturnType<typeof drfadminTradesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminTradesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminTradesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminTradesCreate = (
    newTradeRequest: NewTradeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewTrade>(
      {url: `/drfadmin/trades/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newTradeRequest, signal
    },
      options);
    }




export const getDrfadminTradesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesCreate>>, TError,{data: NewTradeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesCreate>>, TError,{data: NewTradeRequest}, TContext> => {

const mutationKey = ['drfadminTradesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminTradesCreate>>, {data: NewTradeRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminTradesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminTradesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminTradesCreate>>>
    export type DrfadminTradesCreateMutationBody = NewTradeRequest
    export type DrfadminTradesCreateMutationError = ErrorType<ApiError>

    export const useDrfadminTradesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesCreate>>, TError,{data: NewTradeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminTradesCreate>>,
        TError,
        {data: NewTradeRequest},
        TContext
      > => {
      return useMutation(getDrfadminTradesCreateMutationOptions(options), queryClient);
    }
    export const drfadminTradesRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewTrade>(
      {url: `/drfadmin/trades/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminTradesRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/trades/${id}/`
    ] as const;
    }


export const getDrfadminTradesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminTradesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminTradesRetrieve>>> = ({ signal }) => drfadminTradesRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminTradesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminTradesRetrieve>>>
export type DrfadminTradesRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminTradesRetrieve<TData = Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminTradesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminTradesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminTradesRetrieve<TData = Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminTradesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminTradesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminTradesRetrieve<TData = Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminTradesRetrieve<TData = Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminTradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminTradesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminTradesUpdate = (
    id: number,
    newTradeRequest: NewTradeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewTrade>(
      {url: `/drfadmin/trades/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: newTradeRequest, signal
    },
      options);
    }




export const getDrfadminTradesUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesUpdate>>, TError,{id: number;data: NewTradeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesUpdate>>, TError,{id: number;data: NewTradeRequest}, TContext> => {

const mutationKey = ['drfadminTradesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminTradesUpdate>>, {id: number;data: NewTradeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminTradesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminTradesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminTradesUpdate>>>
    export type DrfadminTradesUpdateMutationBody = NewTradeRequest
    export type DrfadminTradesUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminTradesUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesUpdate>>, TError,{id: number;data: NewTradeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminTradesUpdate>>,
        TError,
        {id: number;data: NewTradeRequest},
        TContext
      > => {
      return useMutation(getDrfadminTradesUpdateMutationOptions(options), queryClient);
    }
    export const drfadminTradesPartialUpdate = (
    id: number,
    patchedNewTradeRequest?: PatchedNewTradeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<NewTrade>(
      {url: `/drfadmin/trades/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedNewTradeRequest, signal
    },
      options);
    }




export const getDrfadminTradesPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesPartialUpdate>>, TError,{id: number;data?: PatchedNewTradeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesPartialUpdate>>, TError,{id: number;data?: PatchedNewTradeRequest}, TContext> => {

const mutationKey = ['drfadminTradesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminTradesPartialUpdate>>, {id: number;data?: PatchedNewTradeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminTradesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminTradesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminTradesPartialUpdate>>>
    export type DrfadminTradesPartialUpdateMutationBody = PatchedNewTradeRequest | undefined
    export type DrfadminTradesPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminTradesPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesPartialUpdate>>, TError,{id: number;data?: PatchedNewTradeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminTradesPartialUpdate>>,
        TError,
        {id: number;data?: PatchedNewTradeRequest},
        TContext
      > => {
      return useMutation(getDrfadminTradesPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminTradesDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/trades/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminTradesDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminTradesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminTradesDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminTradesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminTradesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminTradesDestroy>>>

    export type DrfadminTradesDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminTradesDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminTradesDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminTradesDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminTradesDestroyMutationOptions(options), queryClient);
    }
    /**
 * Runs the update_news operation for the specified class, generating news articles based on recent game events using OpenAI.
 * @summary Update News
 */
export const drfadminUpdateNewsCreate = (
    updateNewsRequest: UpdateNewsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UpdateNewsResponse>(
      {url: `/drfadmin/update-news`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateNewsRequest, signal
    },
      options);
    }




export const getDrfadminUpdateNewsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUpdateNewsCreate>>, TError,{data: UpdateNewsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUpdateNewsCreate>>, TError,{data: UpdateNewsRequest}, TContext> => {

const mutationKey = ['drfadminUpdateNewsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUpdateNewsCreate>>, {data: UpdateNewsRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminUpdateNewsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUpdateNewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUpdateNewsCreate>>>
    export type DrfadminUpdateNewsCreateMutationBody = UpdateNewsRequest
    export type DrfadminUpdateNewsCreateMutationError = ErrorType<ApiError>

    /**
 * @summary Update News
 */
export const useDrfadminUpdateNewsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUpdateNewsCreate>>, TError,{data: UpdateNewsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUpdateNewsCreate>>,
        TError,
        {data: UpdateNewsRequest},
        TContext
      > => {
      return useMutation(getDrfadminUpdateNewsCreateMutationOptions(options), queryClient);
    }
    /**
 * Runs the update_population operation for the specified class, calculating population changes based on housing and other factors.
 * @summary Update Population
 */
export const drfadminUpdatePopulationCreate = (
    updatePopulationRequest: UpdatePopulationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UpdatePopulationResponse>(
      {url: `/drfadmin/update-population`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updatePopulationRequest, signal
    },
      options);
    }




export const getDrfadminUpdatePopulationCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUpdatePopulationCreate>>, TError,{data: UpdatePopulationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUpdatePopulationCreate>>, TError,{data: UpdatePopulationRequest}, TContext> => {

const mutationKey = ['drfadminUpdatePopulationCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUpdatePopulationCreate>>, {data: UpdatePopulationRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminUpdatePopulationCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUpdatePopulationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUpdatePopulationCreate>>>
    export type DrfadminUpdatePopulationCreateMutationBody = UpdatePopulationRequest
    export type DrfadminUpdatePopulationCreateMutationError = ErrorType<ApiError>

    /**
 * @summary Update Population
 */
export const useDrfadminUpdatePopulationCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUpdatePopulationCreate>>, TError,{data: UpdatePopulationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUpdatePopulationCreate>>,
        TError,
        {data: UpdatePopulationRequest},
        TContext
      > => {
      return useMutation(getDrfadminUpdatePopulationCreateMutationOptions(options), queryClient);
    }
    /**
 * Runs the update_resources operation for the specified class, updating nation resources based on their purchases and costs.
 * @summary Update Resources
 */
export const drfadminUpdateResourcesCreate = (
    updateResourcesRequest: UpdateResourcesRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UpdateResourcesResponse>(
      {url: `/drfadmin/update-resources`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateResourcesRequest, signal
    },
      options);
    }




export const getDrfadminUpdateResourcesCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUpdateResourcesCreate>>, TError,{data: UpdateResourcesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUpdateResourcesCreate>>, TError,{data: UpdateResourcesRequest}, TContext> => {

const mutationKey = ['drfadminUpdateResourcesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUpdateResourcesCreate>>, {data: UpdateResourcesRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminUpdateResourcesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUpdateResourcesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUpdateResourcesCreate>>>
    export type DrfadminUpdateResourcesCreateMutationBody = UpdateResourcesRequest
    export type DrfadminUpdateResourcesCreateMutationError = ErrorType<ApiError>

    /**
 * @summary Update Resources
 */
export const useDrfadminUpdateResourcesCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUpdateResourcesCreate>>, TError,{data: UpdateResourcesRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUpdateResourcesCreate>>,
        TError,
        {data: UpdateResourcesRequest},
        TContext
      > => {
      return useMutation(getDrfadminUpdateResourcesCreateMutationOptions(options), queryClient);
    }
    export const drfadminUserClassBadgeAwardsList = (
    params?: DrfadminUserClassBadgeAwardsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminUserClassBadgeAwardList>(
      {url: `/drfadmin/user-class-badge-awards/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminUserClassBadgeAwardsListQueryKey = (params?: DrfadminUserClassBadgeAwardsListParams,) => {
    return [
    `/drfadmin/user-class-badge-awards/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminUserClassBadgeAwardsListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError = ErrorType<ApiError>>(params?: DrfadminUserClassBadgeAwardsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminUserClassBadgeAwardsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>> = ({ signal }) => drfadminUserClassBadgeAwardsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminUserClassBadgeAwardsListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>>
export type DrfadminUserClassBadgeAwardsListQueryError = ErrorType<ApiError>


export function useDrfadminUserClassBadgeAwardsList<TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminUserClassBadgeAwardsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUserClassBadgeAwardsList<TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminUserClassBadgeAwardsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUserClassBadgeAwardsList<TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminUserClassBadgeAwardsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminUserClassBadgeAwardsList<TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminUserClassBadgeAwardsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminUserClassBadgeAwardsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminUserClassBadgeAwardsCreate = (
    adminUserClassBadgeAwardRequest: AdminUserClassBadgeAwardRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminUserClassBadgeAward>(
      {url: `/drfadmin/user-class-badge-awards/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminUserClassBadgeAwardRequest, signal
    },
      options);
    }




export const getDrfadminUserClassBadgeAwardsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsCreate>>, TError,{data: AdminUserClassBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsCreate>>, TError,{data: AdminUserClassBadgeAwardRequest}, TContext> => {

const mutationKey = ['drfadminUserClassBadgeAwardsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsCreate>>, {data: AdminUserClassBadgeAwardRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminUserClassBadgeAwardsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUserClassBadgeAwardsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsCreate>>>
    export type DrfadminUserClassBadgeAwardsCreateMutationBody = AdminUserClassBadgeAwardRequest
    export type DrfadminUserClassBadgeAwardsCreateMutationError = ErrorType<ApiError>

    export const useDrfadminUserClassBadgeAwardsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsCreate>>, TError,{data: AdminUserClassBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsCreate>>,
        TError,
        {data: AdminUserClassBadgeAwardRequest},
        TContext
      > => {
      return useMutation(getDrfadminUserClassBadgeAwardsCreateMutationOptions(options), queryClient);
    }
    export const drfadminUserClassBadgeAwardsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminUserClassBadgeAward>(
      {url: `/drfadmin/user-class-badge-awards/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminUserClassBadgeAwardsRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/user-class-badge-awards/${id}/`
    ] as const;
    }


export const getDrfadminUserClassBadgeAwardsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminUserClassBadgeAwardsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>> = ({ signal }) => drfadminUserClassBadgeAwardsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminUserClassBadgeAwardsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>>
export type DrfadminUserClassBadgeAwardsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminUserClassBadgeAwardsRetrieve<TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUserClassBadgeAwardsRetrieve<TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUserClassBadgeAwardsRetrieve<TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminUserClassBadgeAwardsRetrieve<TData = Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminUserClassBadgeAwardsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminUserClassBadgeAwardsUpdate = (
    id: number,
    adminUserClassBadgeAwardRequest: AdminUserClassBadgeAwardRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminUserClassBadgeAward>(
      {url: `/drfadmin/user-class-badge-awards/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUserClassBadgeAwardRequest, signal
    },
      options);
    }




export const getDrfadminUserClassBadgeAwardsUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsUpdate>>, TError,{id: number;data: AdminUserClassBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsUpdate>>, TError,{id: number;data: AdminUserClassBadgeAwardRequest}, TContext> => {

const mutationKey = ['drfadminUserClassBadgeAwardsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsUpdate>>, {id: number;data: AdminUserClassBadgeAwardRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminUserClassBadgeAwardsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUserClassBadgeAwardsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsUpdate>>>
    export type DrfadminUserClassBadgeAwardsUpdateMutationBody = AdminUserClassBadgeAwardRequest
    export type DrfadminUserClassBadgeAwardsUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminUserClassBadgeAwardsUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsUpdate>>, TError,{id: number;data: AdminUserClassBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsUpdate>>,
        TError,
        {id: number;data: AdminUserClassBadgeAwardRequest},
        TContext
      > => {
      return useMutation(getDrfadminUserClassBadgeAwardsUpdateMutationOptions(options), queryClient);
    }
    export const drfadminUserClassBadgeAwardsPartialUpdate = (
    id: number,
    patchedAdminUserClassBadgeAwardRequest?: PatchedAdminUserClassBadgeAwardRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminUserClassBadgeAward>(
      {url: `/drfadmin/user-class-badge-awards/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminUserClassBadgeAwardRequest, signal
    },
      options);
    }




export const getDrfadminUserClassBadgeAwardsPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsPartialUpdate>>, TError,{id: number;data?: PatchedAdminUserClassBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsPartialUpdate>>, TError,{id: number;data?: PatchedAdminUserClassBadgeAwardRequest}, TContext> => {

const mutationKey = ['drfadminUserClassBadgeAwardsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsPartialUpdate>>, {id: number;data?: PatchedAdminUserClassBadgeAwardRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminUserClassBadgeAwardsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUserClassBadgeAwardsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsPartialUpdate>>>
    export type DrfadminUserClassBadgeAwardsPartialUpdateMutationBody = PatchedAdminUserClassBadgeAwardRequest | undefined
    export type DrfadminUserClassBadgeAwardsPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminUserClassBadgeAwardsPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsPartialUpdate>>, TError,{id: number;data?: PatchedAdminUserClassBadgeAwardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminUserClassBadgeAwardRequest},
        TContext
      > => {
      return useMutation(getDrfadminUserClassBadgeAwardsPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminUserClassBadgeAwardsDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/user-class-badge-awards/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminUserClassBadgeAwardsDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminUserClassBadgeAwardsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminUserClassBadgeAwardsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUserClassBadgeAwardsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsDestroy>>>

    export type DrfadminUserClassBadgeAwardsDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminUserClassBadgeAwardsDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUserClassBadgeAwardsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminUserClassBadgeAwardsDestroyMutationOptions(options), queryClient);
    }
    /**
 * Admin view to see all user-generated content (Articles, Comments, Notes)
 * combined and sorted by creation date.
 */
export const drfadminUserContentList = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserGeneratedContentItem[]>(
      {url: `/drfadmin/user-content`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminUserContentListQueryKey = () => {
    return [
    `/drfadmin/user-content`
    ] as const;
    }


export const getDrfadminUserContentListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminUserContentList>>, TError = ErrorType<ApiError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserContentList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminUserContentListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminUserContentList>>> = ({ signal }) => drfadminUserContentList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminUserContentList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminUserContentListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminUserContentList>>>
export type DrfadminUserContentListQueryError = ErrorType<ApiError>


export function useDrfadminUserContentList<TData = Awaited<ReturnType<typeof drfadminUserContentList>>, TError = ErrorType<ApiError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserContentList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUserContentList>>,
          TError,
          Awaited<ReturnType<typeof drfadminUserContentList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUserContentList<TData = Awaited<ReturnType<typeof drfadminUserContentList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserContentList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUserContentList>>,
          TError,
          Awaited<ReturnType<typeof drfadminUserContentList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUserContentList<TData = Awaited<ReturnType<typeof drfadminUserContentList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserContentList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminUserContentList<TData = Awaited<ReturnType<typeof drfadminUserContentList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUserContentList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminUserContentListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Admin ViewSet for managing UserClass instances (user profiles within classes).
 *
 * Provides CRUD operations for user class assignments, allowing admins to:
 * - List all users in their account's classes
 * - Create single or bulk user class assignments
 * - Update user class information (name, profile picture, roles)
 * - Delete user class assignments (except admin users)
 *
 * Features:
 * - Bulk create support via CreateListModelMixin
 * - Filtering by class_name
 * - Ordering by created_at, full_name, or id
 * - Admin user (user_id=1) is hidden from non-admin users
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of admin users
 * - Scoped to current account only
 *
 * Performance:
 * - Uses select_related for user ForeignKey
 * - Ordering handled by CustomOrderingFilter
 */
export const drfadminUsersList = (
    params?: DrfadminUsersListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminUserClassList>(
      {url: `/drfadmin/users/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminUsersListQueryKey = (params?: DrfadminUsersListParams,) => {
    return [
    `/drfadmin/users/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminUsersListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminUsersList>>, TError = ErrorType<ApiError>>(params?: DrfadminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminUsersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminUsersList>>> = ({ signal }) => drfadminUsersList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminUsersList>>>
export type DrfadminUsersListQueryError = ErrorType<ApiError>


export function useDrfadminUsersList<TData = Awaited<ReturnType<typeof drfadminUsersList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminUsersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUsersList>>,
          TError,
          Awaited<ReturnType<typeof drfadminUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUsersList<TData = Awaited<ReturnType<typeof drfadminUsersList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUsersList>>,
          TError,
          Awaited<ReturnType<typeof drfadminUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUsersList<TData = Awaited<ReturnType<typeof drfadminUsersList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminUsersList<TData = Awaited<ReturnType<typeof drfadminUsersList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminUsersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Create one or more UserClass assignments.
 *
 * Supports both single object and bulk creation via array input.
 * Handled by CreateListModelMixin which detects array input.
 */
export const drfadminUsersCreate = (
    adminUserClassCreateRequestRequest?: AdminUserClassCreateRequestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/users/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminUserClassCreateRequestRequest, signal
    },
      options);
    }




export const getDrfadminUsersCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersCreate>>, TError,{data?: AdminUserClassCreateRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersCreate>>, TError,{data?: AdminUserClassCreateRequestRequest}, TContext> => {

const mutationKey = ['drfadminUsersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUsersCreate>>, {data?: AdminUserClassCreateRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminUsersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUsersCreate>>>
    export type DrfadminUsersCreateMutationBody = AdminUserClassCreateRequestRequest | undefined
    export type DrfadminUsersCreateMutationError = ErrorType<ApiError>

    export const useDrfadminUsersCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersCreate>>, TError,{data?: AdminUserClassCreateRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUsersCreate>>,
        TError,
        {data?: AdminUserClassCreateRequestRequest},
        TContext
      > => {
      return useMutation(getDrfadminUsersCreateMutationOptions(options), queryClient);
    }
    /**
 * Admin ViewSet for managing UserClass instances (user profiles within classes).
 *
 * Provides CRUD operations for user class assignments, allowing admins to:
 * - List all users in their account's classes
 * - Create single or bulk user class assignments
 * - Update user class information (name, profile picture, roles)
 * - Delete user class assignments (except admin users)
 *
 * Features:
 * - Bulk create support via CreateListModelMixin
 * - Filtering by class_name
 * - Ordering by created_at, full_name, or id
 * - Admin user (user_id=1) is hidden from non-admin users
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of admin users
 * - Scoped to current account only
 *
 * Performance:
 * - Uses select_related for user ForeignKey
 * - Ordering handled by CustomOrderingFilter
 */
export const drfadminUsersRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminUserClass>(
      {url: `/drfadmin/users/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminUsersRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/users/${id}/`
    ] as const;
    }


export const getDrfadminUsersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminUsersRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminUsersRetrieve>>> = ({ signal }) => drfadminUsersRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminUsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminUsersRetrieve>>>
export type DrfadminUsersRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminUsersRetrieve<TData = Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminUsersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUsersRetrieve<TData = Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminUsersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUsersRetrieve<TData = Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminUsersRetrieve<TData = Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminUsersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Admin ViewSet for managing UserClass instances (user profiles within classes).
 *
 * Provides CRUD operations for user class assignments, allowing admins to:
 * - List all users in their account's classes
 * - Create single or bulk user class assignments
 * - Update user class information (name, profile picture, roles)
 * - Delete user class assignments (except admin users)
 *
 * Features:
 * - Bulk create support via CreateListModelMixin
 * - Filtering by class_name
 * - Ordering by created_at, full_name, or id
 * - Admin user (user_id=1) is hidden from non-admin users
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of admin users
 * - Scoped to current account only
 *
 * Performance:
 * - Uses select_related for user ForeignKey
 * - Ordering handled by CustomOrderingFilter
 */
export const drfadminUsersUpdate = (
    id: number,
    adminUserClassRequest: AdminUserClassRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminUserClass>(
      {url: `/drfadmin/users/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUserClassRequest, signal
    },
      options);
    }




export const getDrfadminUsersUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersUpdate>>, TError,{id: number;data: AdminUserClassRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersUpdate>>, TError,{id: number;data: AdminUserClassRequest}, TContext> => {

const mutationKey = ['drfadminUsersUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUsersUpdate>>, {id: number;data: AdminUserClassRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminUsersUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUsersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUsersUpdate>>>
    export type DrfadminUsersUpdateMutationBody = AdminUserClassRequest
    export type DrfadminUsersUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminUsersUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersUpdate>>, TError,{id: number;data: AdminUserClassRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUsersUpdate>>,
        TError,
        {id: number;data: AdminUserClassRequest},
        TContext
      > => {
      return useMutation(getDrfadminUsersUpdateMutationOptions(options), queryClient);
    }
    /**
 * Admin ViewSet for managing UserClass instances (user profiles within classes).
 *
 * Provides CRUD operations for user class assignments, allowing admins to:
 * - List all users in their account's classes
 * - Create single or bulk user class assignments
 * - Update user class information (name, profile picture, roles)
 * - Delete user class assignments (except admin users)
 *
 * Features:
 * - Bulk create support via CreateListModelMixin
 * - Filtering by class_name
 * - Ordering by created_at, full_name, or id
 * - Admin user (user_id=1) is hidden from non-admin users
 *
 * Security:
 * - Requires IsAdmin permission
 * - Prevents deletion of admin users
 * - Scoped to current account only
 *
 * Performance:
 * - Uses select_related for user ForeignKey
 * - Ordering handled by CustomOrderingFilter
 */
export const drfadminUsersPartialUpdate = (
    id: number,
    patchedAdminUserClassRequest?: PatchedAdminUserClassRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminUserClass>(
      {url: `/drfadmin/users/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminUserClassRequest, signal
    },
      options);
    }




export const getDrfadminUsersPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersPartialUpdate>>, TError,{id: number;data?: PatchedAdminUserClassRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersPartialUpdate>>, TError,{id: number;data?: PatchedAdminUserClassRequest}, TContext> => {

const mutationKey = ['drfadminUsersPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUsersPartialUpdate>>, {id: number;data?: PatchedAdminUserClassRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminUsersPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUsersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUsersPartialUpdate>>>
    export type DrfadminUsersPartialUpdateMutationBody = PatchedAdminUserClassRequest | undefined
    export type DrfadminUsersPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminUsersPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersPartialUpdate>>, TError,{id: number;data?: PatchedAdminUserClassRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUsersPartialUpdate>>,
        TError,
        {id: number;data?: PatchedAdminUserClassRequest},
        TContext
      > => {
      return useMutation(getDrfadminUsersPartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * Delete a UserClass assignment.
 *
 * Prevents deletion of admin users for safety.
 *
 * Returns:
 *     403 if attempting to delete an admin user
 *     200 with success message on successful deletion
 */
export const drfadminUsersDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/users/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminUsersDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminUsersDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUsersDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminUsersDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUsersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUsersDestroy>>>

    export type DrfadminUsersDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminUsersDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUsersDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminUsersDestroyMutationOptions(options), queryClient);
    }
    /**
 * Move a student to a different class.
 *
 * This deactivates the current UserClass (sets is_active=False) and creates
 * a new UserClass in the target class. This is used when reassigning students
 * between classes.
 *
 * Request body:
 * - target_class_id: ID of the ClassName to move to
 * - target_nation_id: Optional ID of the Nation to assign in the new class
 * - roles: Optional list of Role IDs to assign (defaults to copying from source)
 *
 * Returns:
 *     200 with the newly created UserClass
 *     400 if validation fails (e.g., user already has an active UserClass in target class)
 *     403 if not admin
 *     404 if target class/nation not found or invalid roles
 */
export const drfadminUsersMoveToClassCreate = (
    id: number,
    moveToClassRequestRequest: MoveToClassRequestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AdminUserClass>(
      {url: `/drfadmin/users/${id}/move_to_class/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moveToClassRequestRequest, signal
    },
      options);
    }




export const getDrfadminUsersMoveToClassCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersMoveToClassCreate>>, TError,{id: number;data: MoveToClassRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersMoveToClassCreate>>, TError,{id: number;data: MoveToClassRequestRequest}, TContext> => {

const mutationKey = ['drfadminUsersMoveToClassCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUsersMoveToClassCreate>>, {id: number;data: MoveToClassRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminUsersMoveToClassCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUsersMoveToClassCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUsersMoveToClassCreate>>>
    export type DrfadminUsersMoveToClassCreateMutationBody = MoveToClassRequestRequest
    export type DrfadminUsersMoveToClassCreateMutationError = ErrorType<ApiError>

    export const useDrfadminUsersMoveToClassCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersMoveToClassCreate>>, TError,{id: number;data: MoveToClassRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUsersMoveToClassCreate>>,
        TError,
        {id: number;data: MoveToClassRequestRequest},
        TContext
      > => {
      return useMutation(getDrfadminUsersMoveToClassCreateMutationOptions(options), queryClient);
    }
    /**
 * Switch to this UserClass context.
 *
 * Allows users to select which UserClass (class context) they want to operate in.
 * This updates both the session and the user's default selected_user_class.
 *
 * Returns:
 *     200 with success message and selected_user_class_id
 *     403 if the UserClass doesn't belong to the current user
 */
export const drfadminUsersSelectCreate = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SelectUserClassResponse>(
      {url: `/drfadmin/users/${id}/select/`, method: 'POST', signal
    },
      options);
    }




export const getDrfadminUsersSelectCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersSelectCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersSelectCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminUsersSelectCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminUsersSelectCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminUsersSelectCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminUsersSelectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminUsersSelectCreate>>>

    export type DrfadminUsersSelectCreateMutationError = ErrorType<ApiError>

    export const useDrfadminUsersSelectCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminUsersSelectCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminUsersSelectCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminUsersSelectCreateMutationOptions(options), queryClient);
    }
    /**
 * Get all UserClass instances for the current user in the current account.
 */
export const drfadminUsersMyClassesList = (
    params?: DrfadminUsersMyClassesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedAdminUserClassList>(
      {url: `/drfadmin/users/my_classes/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminUsersMyClassesListQueryKey = (params?: DrfadminUsersMyClassesListParams,) => {
    return [
    `/drfadmin/users/my_classes/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminUsersMyClassesListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError = ErrorType<ApiError>>(params?: DrfadminUsersMyClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminUsersMyClassesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminUsersMyClassesList>>> = ({ signal }) => drfadminUsersMyClassesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminUsersMyClassesListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminUsersMyClassesList>>>
export type DrfadminUsersMyClassesListQueryError = ErrorType<ApiError>


export function useDrfadminUsersMyClassesList<TData = Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminUsersMyClassesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUsersMyClassesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminUsersMyClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUsersMyClassesList<TData = Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminUsersMyClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminUsersMyClassesList>>,
          TError,
          Awaited<ReturnType<typeof drfadminUsersMyClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminUsersMyClassesList<TData = Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminUsersMyClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminUsersMyClassesList<TData = Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminUsersMyClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminUsersMyClassesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminUsersMyClassesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminWarningsList = (
    params?: DrfadminWarningsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedWarningList>(
      {url: `/drfadmin/warnings/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminWarningsListQueryKey = (params?: DrfadminWarningsListParams,) => {
    return [
    `/drfadmin/warnings/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminWarningsListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminWarningsList>>, TError = ErrorType<ApiError>>(params?: DrfadminWarningsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminWarningsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminWarningsList>>> = ({ signal }) => drfadminWarningsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminWarningsListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminWarningsList>>>
export type DrfadminWarningsListQueryError = ErrorType<ApiError>


export function useDrfadminWarningsList<TData = Awaited<ReturnType<typeof drfadminWarningsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminWarningsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminWarningsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminWarningsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminWarningsList<TData = Awaited<ReturnType<typeof drfadminWarningsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminWarningsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminWarningsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminWarningsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminWarningsList<TData = Awaited<ReturnType<typeof drfadminWarningsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminWarningsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminWarningsList<TData = Awaited<ReturnType<typeof drfadminWarningsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminWarningsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminWarningsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminWarningsCreate = (
    warningRequest: WarningRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Warning>(
      {url: `/drfadmin/warnings/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: warningRequest, signal
    },
      options);
    }




export const getDrfadminWarningsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsCreate>>, TError,{data: WarningRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsCreate>>, TError,{data: WarningRequest}, TContext> => {

const mutationKey = ['drfadminWarningsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminWarningsCreate>>, {data: WarningRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminWarningsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminWarningsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminWarningsCreate>>>
    export type DrfadminWarningsCreateMutationBody = WarningRequest
    export type DrfadminWarningsCreateMutationError = ErrorType<ApiError>

    export const useDrfadminWarningsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsCreate>>, TError,{data: WarningRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminWarningsCreate>>,
        TError,
        {data: WarningRequest},
        TContext
      > => {
      return useMutation(getDrfadminWarningsCreateMutationOptions(options), queryClient);
    }
    export const drfadminWarningsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Warning>(
      {url: `/drfadmin/warnings/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminWarningsRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/warnings/${id}/`
    ] as const;
    }


export const getDrfadminWarningsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminWarningsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminWarningsRetrieve>>> = ({ signal }) => drfadminWarningsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminWarningsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminWarningsRetrieve>>>
export type DrfadminWarningsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminWarningsRetrieve<TData = Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminWarningsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminWarningsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminWarningsRetrieve<TData = Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminWarningsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminWarningsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminWarningsRetrieve<TData = Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminWarningsRetrieve<TData = Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarningsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminWarningsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminWarningsUpdate = (
    id: number,
    warningRequest: WarningRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Warning>(
      {url: `/drfadmin/warnings/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: warningRequest, signal
    },
      options);
    }




export const getDrfadminWarningsUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsUpdate>>, TError,{id: number;data: WarningRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsUpdate>>, TError,{id: number;data: WarningRequest}, TContext> => {

const mutationKey = ['drfadminWarningsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminWarningsUpdate>>, {id: number;data: WarningRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminWarningsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminWarningsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminWarningsUpdate>>>
    export type DrfadminWarningsUpdateMutationBody = WarningRequest
    export type DrfadminWarningsUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminWarningsUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsUpdate>>, TError,{id: number;data: WarningRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminWarningsUpdate>>,
        TError,
        {id: number;data: WarningRequest},
        TContext
      > => {
      return useMutation(getDrfadminWarningsUpdateMutationOptions(options), queryClient);
    }
    export const drfadminWarningsPartialUpdate = (
    id: number,
    patchedWarningRequest?: PatchedWarningRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Warning>(
      {url: `/drfadmin/warnings/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWarningRequest, signal
    },
      options);
    }




export const getDrfadminWarningsPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsPartialUpdate>>, TError,{id: number;data?: PatchedWarningRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsPartialUpdate>>, TError,{id: number;data?: PatchedWarningRequest}, TContext> => {

const mutationKey = ['drfadminWarningsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminWarningsPartialUpdate>>, {id: number;data?: PatchedWarningRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminWarningsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminWarningsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminWarningsPartialUpdate>>>
    export type DrfadminWarningsPartialUpdateMutationBody = PatchedWarningRequest | undefined
    export type DrfadminWarningsPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminWarningsPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsPartialUpdate>>, TError,{id: number;data?: PatchedWarningRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminWarningsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedWarningRequest},
        TContext
      > => {
      return useMutation(getDrfadminWarningsPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminWarningsDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/warnings/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminWarningsDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminWarningsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminWarningsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminWarningsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminWarningsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminWarningsDestroy>>>

    export type DrfadminWarningsDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminWarningsDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarningsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminWarningsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminWarningsDestroyMutationOptions(options), queryClient);
    }
    export const drfadminWarsList = (
    params?: DrfadminWarsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedWarList>(
      {url: `/drfadmin/wars/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDrfadminWarsListQueryKey = (params?: DrfadminWarsListParams,) => {
    return [
    `/drfadmin/wars/`, ...(params ? [params] : [])
    ] as const;
    }


export const getDrfadminWarsListQueryOptions = <TData = Awaited<ReturnType<typeof drfadminWarsList>>, TError = ErrorType<ApiError>>(params?: DrfadminWarsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminWarsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminWarsList>>> = ({ signal }) => drfadminWarsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminWarsListQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminWarsList>>>
export type DrfadminWarsListQueryError = ErrorType<ApiError>


export function useDrfadminWarsList<TData = Awaited<ReturnType<typeof drfadminWarsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  DrfadminWarsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminWarsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminWarsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminWarsList<TData = Awaited<ReturnType<typeof drfadminWarsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminWarsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminWarsList>>,
          TError,
          Awaited<ReturnType<typeof drfadminWarsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminWarsList<TData = Awaited<ReturnType<typeof drfadminWarsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminWarsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminWarsList<TData = Awaited<ReturnType<typeof drfadminWarsList>>, TError = ErrorType<ApiError>>(
 params?: DrfadminWarsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminWarsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminWarsCreate = (
    warRequest: WarRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<War>(
      {url: `/drfadmin/wars/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: warRequest, signal
    },
      options);
    }




export const getDrfadminWarsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsCreate>>, TError,{data: WarRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsCreate>>, TError,{data: WarRequest}, TContext> => {

const mutationKey = ['drfadminWarsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminWarsCreate>>, {data: WarRequest}> = (props) => {
          const {data} = props ?? {};

          return  drfadminWarsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminWarsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminWarsCreate>>>
    export type DrfadminWarsCreateMutationBody = WarRequest
    export type DrfadminWarsCreateMutationError = ErrorType<ApiError>

    export const useDrfadminWarsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsCreate>>, TError,{data: WarRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminWarsCreate>>,
        TError,
        {data: WarRequest},
        TContext
      > => {
      return useMutation(getDrfadminWarsCreateMutationOptions(options), queryClient);
    }
    export const drfadminWarsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<War>(
      {url: `/drfadmin/wars/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getDrfadminWarsRetrieveQueryKey = (id: number,) => {
    return [
    `/drfadmin/wars/${id}/`
    ] as const;
    }


export const getDrfadminWarsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDrfadminWarsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof drfadminWarsRetrieve>>> = ({ signal }) => drfadminWarsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DrfadminWarsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof drfadminWarsRetrieve>>>
export type DrfadminWarsRetrieveQueryError = ErrorType<ApiError>


export function useDrfadminWarsRetrieve<TData = Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminWarsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminWarsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminWarsRetrieve<TData = Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof drfadminWarsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof drfadminWarsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDrfadminWarsRetrieve<TData = Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDrfadminWarsRetrieve<TData = Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof drfadminWarsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDrfadminWarsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const drfadminWarsUpdate = (
    id: number,
    warRequest: WarRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<War>(
      {url: `/drfadmin/wars/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: warRequest, signal
    },
      options);
    }




export const getDrfadminWarsUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsUpdate>>, TError,{id: number;data: WarRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsUpdate>>, TError,{id: number;data: WarRequest}, TContext> => {

const mutationKey = ['drfadminWarsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminWarsUpdate>>, {id: number;data: WarRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminWarsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminWarsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminWarsUpdate>>>
    export type DrfadminWarsUpdateMutationBody = WarRequest
    export type DrfadminWarsUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminWarsUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsUpdate>>, TError,{id: number;data: WarRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminWarsUpdate>>,
        TError,
        {id: number;data: WarRequest},
        TContext
      > => {
      return useMutation(getDrfadminWarsUpdateMutationOptions(options), queryClient);
    }
    export const drfadminWarsPartialUpdate = (
    id: number,
    patchedWarRequest?: PatchedWarRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<War>(
      {url: `/drfadmin/wars/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedWarRequest, signal
    },
      options);
    }




export const getDrfadminWarsPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsPartialUpdate>>, TError,{id: number;data?: PatchedWarRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsPartialUpdate>>, TError,{id: number;data?: PatchedWarRequest}, TContext> => {

const mutationKey = ['drfadminWarsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminWarsPartialUpdate>>, {id: number;data?: PatchedWarRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  drfadminWarsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminWarsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminWarsPartialUpdate>>>
    export type DrfadminWarsPartialUpdateMutationBody = PatchedWarRequest | undefined
    export type DrfadminWarsPartialUpdateMutationError = ErrorType<ApiError>

    export const useDrfadminWarsPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsPartialUpdate>>, TError,{id: number;data?: PatchedWarRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminWarsPartialUpdate>>,
        TError,
        {id: number;data?: PatchedWarRequest},
        TContext
      > => {
      return useMutation(getDrfadminWarsPartialUpdateMutationOptions(options), queryClient);
    }
    export const drfadminWarsDestroy = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/drfadmin/wars/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDrfadminWarsDestroyMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsDestroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['drfadminWarsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drfadminWarsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  drfadminWarsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrfadminWarsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof drfadminWarsDestroy>>>

    export type DrfadminWarsDestroyMutationError = ErrorType<ApiError>

    export const useDrfadminWarsDestroy = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drfadminWarsDestroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof drfadminWarsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDrfadminWarsDestroyMutationOptions(options), queryClient);
    }
